// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:38:47.275Z
// Property: Cottages at Crestview (ID: 6767906449165596)
// Collections: 24 amenities, 12 floorplans (live), 47 photos, 75 POIs, 2 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165596",
  "property_external_id": "df6eqhj",
  "property_zillow_url": "https://www.zillow.com/apartments/wichita-ks/cottages-at-crestview/CkBGnt/",
  "property_apartments_url": "https://www.apartments.com/cottages-at-crestview-wichita-ks/df6eqhj/",
  "property_google_business_url": "https://www.google.com/maps/place/Cottages+at+Crestview/data=!4m2!3m1!1s0x0:0x4ce4790296832f82?sa=X&ved=2ahUKEwjq_Zzr9bySAxVfEFkFHQjWCzkQ_BJ6BAgUEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cottages-at-crestview",
  "property_name": "Cottages at Crestview",
  "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/cottages-at-crestview/",
  "property_domain": null,
  "property_address": "110 N 127th St E",
  "property_full_address": "110 N 127th St E, Wichita, KS, 67206",
  "property_address_1": "110 N 127th St E",
  "property_address_2": null,
  "property_address_city": "Wichita",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "67206",
  "property_address_country": "US",
  "property_address_county": "Sedgwick County",
  "property_neighborhood_address": "Outer Sedgwick County",
  "property_address_latitude": "37.6881",
  "property_address_longitude": "-97.1889",
  "property_email": "crestview@caseusa.com",
  "property_phone": "(316) 745-2994",
  "property_call_tracking_phone": "844-308-1844",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Cottages at Crestview in Wichita, Kansas, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans, and enjoy amenities like a sparkling pool, modern fitness center, and a delightful dog park. Your ideal home awaits—browse our availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Cottages at Crestview, your ideal retreat in Wichita, Kansas, where comfort meets convenience. Our community offers a range of thoughtfully designed floor plans, featuring one, two, and three-bedroom apartments that cater to diverse lifestyles. Experience an array of exceptional amenities that enhance your living experience. Dive into relaxation at our sparkling pool, stay fit in our well-equipped fitness center, or gather with friends at our welcoming clubhouse.\n\nThe Cottages at Crestview provide controlled access for added peace of mind, alongside a dedicated on-site property manager to ensure your needs are met. Your furry friends will love our expansive pet play area and dog park, while you can enjoy leisurely afternoons on the sundeck, complete with cabana and grilling stations. Our business center and lounge area offer the perfect space for productivity and relaxation.\n\nInside your apartment, discover modern features such as stainless steel appliances, air conditioning, and ample storage space. Enjoy the warmth of a fireplace, the elegance of vaulted ceilings, and the convenience of a washer/dryer hookup. Many units also boast private balconies or patios, perfect for enjoying the picturesque views of our landscaped grounds.\n\nWith easy access to local attractions and a vibrant community atmosphere, Cottages at Crestview is more than a place to live – it’s a place to thrive. \n\nFind your new home today—browse our availability or schedule a tour to visit our beautiful community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-4ce4-71fe-91d3-ddb4737d3be8.webp",
  "property_featured_image_media": {
    "alt_text": "The Crest View luxury apartments monument sign.",
    "public_id": "019cfb3c-4ce4-71fe-91d3-ddb4737d3be8",
    "storage_key": "property/6767906449165596/019cfb3c-4ce4-71fe-91d3-ddb4737d3be8.webp",
    "width": 2700,
    "height": 1800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "348",
  "property_year_built": "2019",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "175-325",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions include Akita, American Pit Bull Terrier (aka American Staffordshire Terrier, Pit Bull, Bull Terrier, Staffordshire Terrier), Chow Chow (aka Chow), Rottweiler, German Shepherd, Doberman Pinscher, Wolf hybrid (i.e. wolf mixed with any breed),  and mixes of any breed listed.",
  "property_pet_policy_description": "Pet Fee equal to 1/2 of one month's rent.  Pet Rent is $30 per month per pet. Limit of 2 pets per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://cottagesatcrestviewapartmentswichita.securecafe.com/onlineleasing/cottages-at-crestview/floorplans.aspx",
  "property_resident_portal_url": "https://cottagesatcrestviewapartmentswichita.securecafe.com/residentservices/cottages-at-crestview/userlogin.aspx",
  "property_apply_now_url": "https://cottagesatcrestviewapartmentswichita.securecafe.com/onlineleasing/cottages-at-crestview/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-e573-7027-95fd-6ccc2975a6fd.webp",
  "property_primary_logo_media": {
    "alt_text": "The Cottages at Crestview Luxury Apartments logo.",
    "public_id": "019cfb3c-e573-7027-95fd-6ccc2975a6fd",
    "storage_key": "property/6767906449165596/019cfb3c-e573-7027-95fd-6ccc2975a6fd.webp",
    "width": 1441,
    "height": 324
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3e-0125-7235-aeb1-223573c46b40.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb3e-0125-7235-aeb1-223573c46b40",
    "storage_key": "property/6767906449165596/019cfb3e-0125-7235-aeb1-223573c46b40.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3e-1602-7280-a2af-94ff2233e715.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Cottages at Crest View luxury apartments logo",
    "public_id": "019cfb3e-1602-7280-a2af-94ff2233e715",
    "storage_key": "property/6767906449165596/019cfb3e-1602-7280-a2af-94ff2233e715.webp",
    "width": 640,
    "height": 144
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3e-3691-740c-8dd8-decc2e0d3086.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Cottages at Crestview luxury apartments logo",
    "public_id": "019cfb3e-3691-740c-8dd8-decc2e0d3086",
    "storage_key": "property/6767906449165596/019cfb3e-3691-740c-8dd8-decc2e0d3086.webp",
    "width": 640,
    "height": 144
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#324d58",
  "property_secondary_color": "#5e5e5e",
  "property_font_color": null,
  "property_color_4": "#cac4b8",
  "property_color_3": "#eae0c8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1108",
  "property_sqft_min": "789",
  "property_sqft_max": "1108",
  "property_price_range": "1224 - 1544",
  "property_price_min": "1224",
  "property_price_max": "1544",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/CottagesatCrestviewApts/photos/find-your-dream-kitchen-at-cottages-at-crestview-our-upscale-kitchens-are-equipp/3417642548339814/",
  "property_instagram_url": "https://www.instagram.com/cottagesatcrestviewks/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJlyMYez79uocRgi-DlgJ55Ew",
  "property_youtube_url": "https://www.youtube.com/watch?v=X_sCggfqVGo&t=81",
  "property_yelp_url": "https://www.yelp.com/biz/cottages-at-crestview-wichita-3",
  "property_tiktok_url": "https://www.tiktok.com/@cottagesatcrestview",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cottages at Crestview",
  "property_home_romance_title": "Feel the Love in Your New Apartment Home Today!",
  "property_home_amenities_blurb": "Welcome to Cottages at Crestview in Wichita, Kansas, where comfort meets style! Choose from a variety of thoughtfully designed one, two, and three-bedroom floor plans. Enjoy exclusive amenities like a sparkling pool, modern fitness center, and pet-friendly dog park, all within a secure, gated community. Your ideal home awaits!",
  "property_home_floorplans_blurb": "Welcome to Cottages at Crestview, Wichita’s charming retreat! Choose from thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Each home offers a unique blend of comfort and convenience. Browse our available apartment homes today and discover your perfect sanctuary in this vibrant community!",
  "property_home_gallery_blurb": "At Cottages at Crestview in Wichita, Kansas, our diverse floor plans—one, two, and three bedrooms—set the stage for your ideal lifestyle. With amenities like a sparkling pool, fitness center, and serene pet play area, picture yourself living here, where comfort meets convenience in every corner!",
  "property_home_neighborhood_blurb": "Welcome to Cottages at Crestview in vibrant Wichita, Kansas, where charming one, two, and three-bedroom apartments await. Positioned near cultural gems like the Kansas Aviation Museum and Frank Lloyd Wright's Allen House, our community offers easy access to nature at Great Plains Nature Center and Edgemoor Park. Embrace urban living today!",
  "property_home_reviews_blurb": "At Cottages at Crestview in Wichita, residents appreciate the exceptional service and attention to detail. One resident shares, \"the management and office staff bent over backwards to help us each step of the way.\" Immerse yourself in a vibrant community where your comfort and lifestyle are a top priority!",
  "property_neighborhood_blurb": "Nestled in the heart of Wichita, Cottages at Crestview offers more than just stylish one, two, and three-bedroom homes. Experience a vibrant community with prime access to the Great Plains Nature Center, Woolsey Hall, and the Kansas Aviation Museum. See what's around our community and uncover local favorites waiting to be discovered!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cottages at Crestview in Wichita, Kansas, your perfect sanctuary awaits. Choose from one, two, or three-bedroom layouts and indulge in remarkable amenities such as a sparkling pool, fitness center, and dog park. Every detail, from vaulted ceilings to stainless steel appliances, ensures a lifestyle of comfort and convenience.",
  "property_applynow_blurb": "Welcome to Cottages at Crestview in Wichita, Kansas, where modern living meets comfort. Choose from spacious one, two, or three-bedroom floor plans with amenities like a sparkling pool, fitness center, and pet-friendly areas. Enjoy sunsets from your private patio and experience the lifestyle you've always dreamed of—lease online today!",
  "property_contactus_blurb": "At Cottages at Crestview in Wichita, Kansas, we offer spacious floor plans designed to suit your lifestyle—choose from one, two, or three-bedroom apartments that blend comfort with style. Have questions? Our friendly leasing team is here to assist you every step of the way! Reach out today!",
  "property_faqs_blurb": "At Cottages at Crestview in Wichita, Kansas, we offer a range of thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom homes. Have questions? Our FAQs page is your go-to resource for insights about our vibrant community and all it has to offer.",
  "property_floorplans_blurb": "Welcome to Cottages at Crestview in Wichita, Kansas, where comfort meets style in our thoughtfully designed floor plans. Choose from cozy one-bedroom, spacious two-bedroom, or luxurious three-bedroom layouts. Each home invites you to unwind in a space that truly feels like your own. Browse our available apartment homes today!",
  "property_gallery_blurb": "At Cottages at Crestview in Wichita, Kansas, our diverse floor plans—one, two, and three bedrooms—are designed for your lifestyle. Enjoy sun-soaked afternoons by the pool, invigorating workouts in our fitness center, or cozy nights by the fireplace. Picture yourself living here, where comfort meets community in every detail.",
  "property_interactivemap_blurb": "Experience the charm of Cottages at Crestview, where comfort meets style in Wichita, Kansas. Choose from our spacious one, two, or three-bedroom apartments, each featuring modern amenities like stainless steel appliances, a relaxing pool, and a vibrant dog park. Use our interactive map to find your perfect home today!",
  "property_pets_blurb": "At Cottages at Crestview in Wichita, Kansas, your furry friends are part of the family! With a welcoming environment that accommodates dogs and cats (restrictions apply), you can enjoy spacious living alongside your two pets. Embrace a vibrant community where every tail can wag with joy!",
  "property_referafriend_blurb": "At Cottages at Crestview in Wichita, Kansas, our vibrant community welcomes you home with thoughtfully designed one, two, and three-bedroom floor plans. Share the joy of great living with friends! Refer a neighbor today and enjoy the comforts of home together. Great friends make great neighbors!",
  "property_residentaccess_blurb": "At Cottages at Crestview in Wichita, Kansas, your perfect home awaits in our thoughtfully designed one, two, and three-bedroom floor plans. Unlock seamless living by accessing your resident portal; effortlessly pay rent, schedule maintenance, and stay connected to community updates—all at your fingertips!",
  "property_reviews_blurb": "At Cottages at Crestview in Wichita, our residents rave about the personalized service and inviting atmosphere. One resident shares, “We really appreciate everything they do to make our daily lives as pleasant and peaceful as possible.” Experience community living where attention to detail enhances your everyday comfort. ",
  "property_created_at": "1753982381331",
  "property_scheduletour_blurb": "At Cottages at Crestview in Wichita, Kansas, you’ll find thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Experience modern living and vibrant community vibes—don’t just take our word for it! Check out our residents’ testimonials and schedule your tour today!",
  "property_thankyou_blurb": "Thank you for reaching out! At Cottages at Crestview in Wichita, Kansas, our diverse floor plans—including stylish one, two, and three-bedroom options—are designed to fit your lifestyle. A team member will connect with you soon to guide you in finding your ideal home. ",
  "property_virtualtours_blurb": "At Cottages at Crestview in Wichita, Kansas, our thoughtfully designed one, two, and three-bedroom floor plans blend comfort with style. Experience the warmth of home as you explore our vibrant community. Ready to envision your future? Take a virtual tour today and see what awaits you!",
  "property_copyright": "2025 All Rights Reserved. Cottages at Crestview",
  "property_seo_title_home": "Cottages at Crestview |  Apartments in Wichita, Kansas",
  "property_seo_description_home": "Discover Cottages at Crestview in Wichita! Enjoy 1-3 bedroom apartments with a pool, fitness center, and dog park. Experience the charm today!",
  "property_seo_title_floorplans": "Floor Plans | Wichita, Kansas Apartments for Rent",
  "property_seo_description_floorplans": "Discover your perfect home at Cottages at Crestview, Wichita, KS! Choose from cozy one-bedroom to spacious three-bedroom floor plans.",
  "property_seo_title_amenities": "Amenities | Wichita, Kansas Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort at Cottages at Crestview, Wichita! Enjoy a pool, fitness center, pet park, and stylish apartments with modern amenities.",
  "property_seo_title_gallery": "Gallery | Apartments in Wichita, Kansas",
  "property_seo_description_gallery": "Picture life at Cottages at Crestview in Wichita! Stunning floor plans, luxury amenities, and pet-friendly spaces await. Your ideal home is just a click away!",
  "property_seo_title_virtualtours": "Virtual Tours | Cottages at Crestview Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Cottages at Crestview in Wichita, KS. Take a virtual tour and envision your new home with our one, two, and three-bedroom layouts!",
  "property_seo_title_interactivemap": "Interactive Map | Cottages at Crestview Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Cottages at Crestview in Wichita! Use our interactive map to explore our stylish apartments with fantastic amenities and pricing.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Wichita, Kansas",
  "property_seo_description_neighborhood": "Uncover the charm of Wichita at Cottages at Crestview. See local favorites and hidden gems in our vibrant neighborhood. Your next adventure awaits!",
  "property_seo_title_contact": "Contact Us | Cottages at Crestview",
  "property_seo_description_contact": "Connect with the Cottages at Crestview in Wichita! Explore our one to three-bedroom floor plans. Have questions? Reach out to our friendly leasing team now!",
  "property_seo_title_faqs": "FAQs | Apartments in Wichita, Kansas",
  "property_seo_description_faqs": "Find answers to your questions at Cottages at Crestview! From pet amenities to floor plans, our FAQs reveal everything about your future home in Wichita.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Wichita, Kansas",
  "property_seo_description_reviews": "Discover residents' experiences at Cottages at Crestview in Wichita, KS! Enjoy our vibrant community, stellar amenities, and beautiful floor plans. ",
  "property_seo_title_applynow": "Apply Now | Apartments in Wichita, Kansas",
  "property_seo_description_applynow": "Find your ideal Wichita home at Cottages at Crestview. Enjoy spacious floor plans, top-notch amenities, and a welcoming community. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Cottages at Crestview",
  "property_seo_description_residentaccess": "Connect with convenience at Cottages at Crestview! Log in to your resident portal for rent payments, maintenance requests, and seamless community access.",
  "property_seo_title_referafriend": "Refer A Friend | Cottages at Crestview",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Cottages at Crestview in Wichita and build a community you'll love. Share the good life today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cottages at Crestview",
  "property_seo_description_scheduletour": "Experience the charm of Cottages at Crestview in Wichita, KS. Schedule a tour today and see what makes our community your perfect home!",
  "property_seo_title_privacy": "Privacy Policy | Cottages at Crestview",
  "property_seo_description_privacy": "Protecting your personal information is our priority at Cottages at Crestview. Learn how we ensure your privacy in Wichita’s serene apartment community.",
  "property_seo_title_accessibility": "Website Accessibility | Cottages at Crestview",
  "property_seo_description_accessibility": "At Cottages at Crestview in Wichita, we prioritize accessibility and digital inclusion for all. Join our welcoming community today!",
  "property_seo_title_sitemap": "Sitemap | Cottages at Crestview",
  "property_seo_description_sitemap": "Uncover every corner of Cottages at Crestview in Wichita, KS. Our sitemap guides you through vibrant living options and community features. Start your journey!",
  "property_seo_title_thankyou": "Thank You | Cottages at Crestview",
  "property_seo_description_thankyou": "Thank you for reaching out to Cottages at Crestview in Wichita! Our team will connect with you soon to help you find your perfect home. Exciting living awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Wichita, Kansas",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865080030",
  "amenities": [
    {
      "id": "ec_614f84381500f58df266f1ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127396433",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71719fb2e0e18844f0b74c8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127396439",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be8efc90ae712df927f83743",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127396441",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e9053f7e263043db63fb4dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127396442",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_daf844ef339b07c2b1d6eb85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127396443",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84c764b8e662ea5d39c30156",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127396444",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3505e2a9d1948541817c291b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127396446",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44870b3f156cbcf90a711542",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "128042502",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f89df19258bc1e6d330544f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127396447",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6cd7ce8a05727e406ab1fa91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127396448",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17a7e6f714dbc799324cd60d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "128017313",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3088b90737c2e6a1a34bbb0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127397931",
      "title": "View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70562de9c3e70af85f2fef15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127397932",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5f33f32d3e9876dcd18e312",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127397933",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_89f68d9e687aca2287f2644e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127397934",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a39a0f1b0f42ca765a78f8a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127397935",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fac4c7974e190be2a752f25f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127397936",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3bcc9902c7fa602ce9a3e837",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127397937",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1cefa5f351e1abd99d83bc32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127397938",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_025a28837bac4de9cd4aaa4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127397939",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a96c105496d8057dca8f56d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127397940",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5efb0ab58b4fcfb24114f479",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127397941",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1d009dadb0cf404bc9ce9f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127397942",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75b6650f15bd74a4a8192a49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "yardi",
      "external_id": "127397943",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_accda2b9-e653-4d44-9ebf-dd288f26363d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d07db-c756-7331-8dee-0071508a15ed.webp",
      "image_media": {
        "alt_text": "A bathroom with a shelf and two framed pictures on the wall.",
        "public_id": "019d07db-c756-7331-8dee-0071508a15ed",
        "storage_key": "property/6767906449165596/019d07db-c756-7331-8dee-0071508a15ed.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "This apartment laundry room features convenient washer hookups, ample shelving for storage, and decorative touches like framed art and stylish accents.",
      "link": "",
      "alt_text": "A bathroom with a shelf and two framed pictures on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304647.JPG"
    },
    {
      "id": "custom_b2a34278-d456-4746-be9d-5bceafcb1007",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-4a1a-765a-9021-90e1e5357fc2.webp",
      "image_media": {
        "alt_text": "A large house with a driveway in front of it.",
        "public_id": "019cfb3c-4a1a-765a-9021-90e1e5357fc2",
        "storage_key": "property/6767906449165596/019cfb3c-4a1a-765a-9021-90e1e5357fc2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to our community's clubhouse and main entrance, complete with a golf cart for easy resident transport.",
      "link": "",
      "alt_text": "A large house with a driveway in front of it.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304421%20(1).JPG"
    },
    {
      "id": "custom_89b12664-b9a6-45a2-a4f2-edc2ccb14991",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d07db-c720-71bb-9c56-b415aeec1654.webp",
      "image_media": {
        "alt_text": "Pet washing station with dog bed, food bowls, and artwork.",
        "public_id": "019d07db-c720-71bb-9c56-b415aeec1654",
        "storage_key": "property/6767906449165596/019d07db-c720-71bb-9c56-b415aeec1654.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Community",
      "description": "Dedicated pet washing station featuring a comfortable dog bed, stainless steel food bowls, and a playful 'Life is a Ball' dog-themed artwork.",
      "link": "",
      "alt_text": "Pet washing station with dog bed, food bowls, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304957.JPG"
    },
    {
      "id": "custom_db4098aa-78d8-40a6-8a76-df6c41113970",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-49fb-766d-b2f3-2be959a85133.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and subway tile backsplash.",
        "public_id": "019cfb3c-49fb-766d-b2f3-2be959a85133",
        "storage_key": "property/6767906449165596/019cfb3c-49fb-766d-b2f3-2be959a85133.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring white shaker cabinets, granite countertops, a stainless steel range, and a deep basin sink.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304582%20(1).JPG"
    },
    {
      "id": "custom_7f874e64-1c24-4ecc-8fb1-77c59d381585",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-4c99-7145-975e-9efce456abc7.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with a courtyard and sculpture.",
        "public_id": "019cfb3c-4c99-7145-975e-9efce456abc7",
        "storage_key": "property/6767906449165596/019cfb3c-4c99-7145-975e-9efce456abc7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Discover the sophisticated design of our community's exterior, featuring a serene courtyard with a modern sculpture and inviting architectural elements.",
      "link": "",
      "alt_text": "Modern apartment building exterior with a courtyard and sculpture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304451%20(1).JPG"
    },
    {
      "id": "custom_029599c2-b9b0-4f28-9882-7f30eac848f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-4ce4-71fe-91d3-ddb4737d3be8.webp",
      "image_media": {
        "alt_text": "Crest View luxury apartments monument sign with landscaping and building in the background",
        "public_id": "019cfb3c-4ce4-71fe-91d3-ddb4737d3be8",
        "storage_key": "property/6767906449165596/019cfb3c-4ce4-71fe-91d3-ddb4737d3be8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Crest View luxury apartments! This monument sign, featuring the property name, is surrounded by lush landscaping and complemented by the apartment buildings in the background.",
      "link": "",
      "alt_text": "Crest View luxury apartments monument sign with landscaping and building in the background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304296%20(3).JPG"
    },
    {
      "id": "custom_06096386-9bbd-4a18-9c3d-c5f4c7eae8f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-4ca9-7708-80ca-fc0a11fa9f37.webp",
      "image_media": {
        "alt_text": "A dining room with a table and chairs.",
        "public_id": "019cfb3c-4ca9-7708-80ca-fc0a11fa9f37",
        "storage_key": "property/6767906449165596/019cfb3c-4ca9-7708-80ca-fc0a11fa9f37.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy a delightful dining experience in this elegant space, perfect for intimate meals or entertaining guests. Features a stylish round table with seating for four, complemented by sophisticated wall art and easy access to a balcony.",
      "link": "",
      "alt_text": "A dining room with a table and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304602%20(1).JPG"
    },
    {
      "id": "custom_8a729227-6786-402b-b3b2-be0983ed2959",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-4c82-7408-b498-44b9b014cc0b.webp",
      "image_media": {
        "alt_text": "Community business center with computers and seating.",
        "public_id": "019cfb3c-4c82-7408-b498-44b9b014cc0b",
        "storage_key": "property/6767906449165596/019cfb3c-4c82-7408-b498-44b9b014cc0b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Work or relax in our community business center, equipped with computers and comfortable seating for your convenience.",
      "link": "",
      "alt_text": "Community business center with computers and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304362%20(1).JPG"
    },
    {
      "id": "custom_3d872428-1b1e-40d4-85f6-d10c6e824602",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-5ae4-777b-9498-b41e945e2c9d.webp",
      "image_media": {
        "alt_text": "A dining room with a table and chairs.",
        "public_id": "019cfb3c-5ae4-777b-9498-b41e945e2c9d",
        "storage_key": "property/6767906449165596/019cfb3c-5ae4-777b-9498-b41e945e2c9d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, featuring a charming round table and comfortable seating, with abundant natural light streaming through the large windows.",
      "link": "",
      "alt_text": "A dining room with a table and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304697%20(1).JPG"
    },
    {
      "id": "custom_51340b2e-5e79-4916-9b4f-b7add7a92f46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-5af3-729c-8687-9bc6aab05bb9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019cfb3c-5af3-729c-8687-9bc6aab05bb9",
        "storage_key": "property/6767906449165596/019cfb3c-5af3-729c-8687-9bc6aab05bb9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, surrounded by comfortable lounge seating. The perfect spot to relax and soak up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool and lounge area with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304486%20(1).JPG"
    },
    {
      "id": "custom_ef82eb07-d900-45c1-b63a-76869df977bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-5b0d-7401-9aeb-08f4746d230b.webp",
      "image_media": {
        "alt_text": "A living room with a purple chair and a grey couch.",
        "public_id": "019cfb3c-5b0d-7401-9aeb-08f4746d230b",
        "storage_key": "property/6767906449165596/019cfb3c-5b0d-7401-9aeb-08f4746d230b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this spacious living and dining area, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "A living room with a purple chair and a grey couch.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304572%20(1).JPG"
    },
    {
      "id": "custom_c15f4855-e0f7-4cec-b0a6-a4dff580b263",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-605c-7557-af23-b508d473b1a8.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and ceiling fan.",
        "public_id": "019cfb3c-605c-7557-af23-b508d473b1a8",
        "storage_key": "property/6767906449165596/019cfb3c-605c-7557-af23-b508d473b1a8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush king-size bed and ample storage.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304827%20(1).JPG"
    },
    {
      "id": "custom_bad5bc6b-f313-4429-919b-05af600b0c47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-639b-775c-b970-fdb7b2785a5e.webp",
      "image_media": {
        "alt_text": "A bedroom with a large bed and a ceiling fan.",
        "public_id": "019cfb3c-639b-775c-b970-fdb7b2785a5e",
        "storage_key": "property/6767906449165596/019cfb3c-639b-775c-b970-fdb7b2785a5e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom, featuring a plush king-size bed, a ceiling fan for added comfort, and ample storage with a dresser and closet.",
      "link": "",
      "alt_text": "A bedroom with a large bed and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304872%20(1).JPG"
    },
    {
      "id": "custom_859293ab-cc8c-4daa-9f8a-074f93627cac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-6710-75d9-b894-180e5821b4b6.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with dual sinks, dark wood cabinets, and marble countertops.",
        "public_id": "019cfb3c-6710-75d9-b894-180e5821b4b6",
        "storage_key": "property/6767906449165596/019cfb3c-6710-75d9-b894-180e5821b4b6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with dual sinks, ample storage in dark wood cabinets, and elegant marble countertops.",
      "link": "",
      "alt_text": "Bathroom vanity with dual sinks, dark wood cabinets, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304852%20(1).JPG"
    },
    {
      "id": "custom_765a719d-6f51-431b-add7-7456af4f1255",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-6773-703f-997e-dab18b3b3638.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with bar seating and dining table.",
        "public_id": "019cfb3c-6773-703f-997e-dab18b3b3638",
        "storage_key": "property/6767906449165596/019cfb3c-6773-703f-997e-dab18b3b3638.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring a breakfast bar, dining table, and comfortable seating, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area with bar seating and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304892%20(1).JPG"
    },
    {
      "id": "custom_d46d3f85-f535-40ad-8a00-c924eb6c77d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-6b35-7253-8aa7-b2526cd64ed3.webp",
      "image_media": {
        "alt_text": "A room with a dining table and chairs.",
        "public_id": "019cfb3c-6b35-7253-8aa7-b2526cd64ed3",
        "storage_key": "property/6767906449165596/019cfb3c-6b35-7253-8aa7-b2526cd64ed3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy a versatile living space with a dedicated dining area and a convenient work-from-home desk.",
      "link": "",
      "alt_text": "A room with a dining table and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304692%20(1).JPG"
    },
    {
      "id": "custom_29ef3cd9-511b-45db-a19e-d09b59bfdcbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-6c3d-70a8-834d-31cf2a3118ef.webp",
      "image_media": {
        "alt_text": "Outdoor dog park with agility equipment and benches, next to apartment buildings.",
        "public_id": "019cfb3c-6c3d-70a8-834d-31cf2a3118ef",
        "storage_key": "property/6767906449165596/019cfb3c-6c3d-70a8-834d-31cf2a3118ef.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our spacious outdoor dog park, complete with agility equipment and comfortable seating, offering a fun space for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Outdoor dog park with agility equipment and benches, next to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7305076.JPG"
    },
    {
      "id": "custom_36764ede-e54c-46c1-b164-3886df86e8b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-6d16-7063-af62-9e1acb4320de.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with grills, picnic tables, and a fireplace.",
        "public_id": "019cfb3c-6d16-7063-af62-9e1acb4320de",
        "storage_key": "property/6767906449165596/019cfb3c-6d16-7063-af62-9e1acb4320de.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining at our community grilling station, complete with grills, shaded picnic tables, and a cozy fireplace.",
      "link": "",
      "alt_text": "Outdoor grilling area with grills, picnic tables, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304437%20(1).JPG"
    },
    {
      "id": "custom_1a5039af-0932-48cf-aede-ac5ba79f3e21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-6f22-72cd-8eee-e5f53df78dcf.webp",
      "image_media": {
        "alt_text": "Crest View community lounge with pool table, bar seating, and a large glass garage door opening to an outdoor grilling area.",
        "public_id": "019cfb3c-6f22-72cd-8eee-e5f53df78dcf",
        "storage_key": "property/6767906449165596/019cfb3c-6f22-72cd-8eee-e5f53df78dcf.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy leisure time in the Crest View community lounge, featuring a billiards table, bar seating, and an outdoor grilling patio accessible through a stylish garage door.",
      "link": "",
      "alt_text": "Crest View community lounge with pool table, bar seating, and a large glass garage door opening to an outdoor grilling area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304386%20(1).JPG"
    },
    {
      "id": "custom_9061a805-1c99-4fc4-a25c-ed2530daa83b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-6ff8-71fd-a288-d5cfd0318045.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, and entertainment center with a TV.",
        "public_id": "019cfb3c-6ff8-71fd-a288-d5cfd0318045",
        "storage_key": "property/6767906449165596/019cfb3c-6ff8-71fd-a288-d5cfd0318045.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed living room, featuring a plush sectional sofa, a stylish coffee table, and a modern entertainment center perfect for movie nights.",
      "link": "",
      "alt_text": "Spacious living room with a sectional sofa, coffee table, and entertainment center with a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304902%20(1).JPG"
    },
    {
      "id": "custom_3348ec77-1a89-4736-80cf-312036b932ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-763b-7749-8dbf-1af9c76d8806.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building entrance and surrounding landscape.",
        "public_id": "019cfb3c-763b-7749-8dbf-1af9c76d8806",
        "storage_key": "property/6767906449165596/019cfb3c-763b-7749-8dbf-1af9c76d8806.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Discover our welcoming apartment community featuring a well-maintained exterior and attractive landscaping, creating a pleasant living environment.",
      "link": "",
      "alt_text": "Exterior view of the apartment building entrance and surrounding landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304312%20(1).JPG"
    },
    {
      "id": "custom_e3694a39-872f-471e-bfbf-0604e606c98d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-7282-7228-89c1-017a498eebf4.webp",
      "image_media": {
        "alt_text": "A bedroom with a large bed and a painting on the wall.",
        "public_id": "019cfb3c-7282-7228-89c1-017a498eebf4",
        "storage_key": "property/6767906449165596/019cfb3c-7282-7228-89c1-017a498eebf4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant ceiling fan, ample closet space, and a vibrant butterfly artwork to enhance the room's ambiance.",
      "link": "",
      "alt_text": "A bedroom with a large bed and a painting on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304882%20(1).JPG"
    },
    {
      "id": "custom_1a23f2f5-bb57-4912-a149-7a99f4e19b79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-7899-7578-aa8d-5f569ea19c15.webp",
      "image_media": {
        "alt_text": "A bedroom with a bed, pillows, and pictures on the wall.",
        "public_id": "019cfb3c-7899-7578-aa8d-5f569ea19c15",
        "storage_key": "property/6767906449165596/019cfb3c-7899-7578-aa8d-5f569ea19c15.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in the spacious bedroom featuring a comfortable bed, modern decor, and ample closet space.",
      "link": "",
      "alt_text": "A bedroom with a bed, pillows, and pictures on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304947%20(1).JPG"
    },
    {
      "id": "custom_46fc5ccc-a6ee-4377-a650-7aeebf74d122",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-7d49-73d6-8a5f-7fb1370185b7.webp",
      "image_media": {
        "alt_text": "Apartment complex with a swimming pool and courtyard.",
        "public_id": "019cfb3c-7d49-73d6-8a5f-7fb1370185b7",
        "storage_key": "property/6767906449165596/019cfb3c-7d49-73d6-8a5f-7fb1370185b7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Discover the amenities at our apartment complex, featuring a sparkling swimming pool and a beautifully landscaped courtyard.",
      "link": "",
      "alt_text": "Apartment complex with a swimming pool and courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304427%20(1).JPG"
    },
    {
      "id": "custom_1db58ed9-1ab2-4edf-b6e3-3afdd95df590",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-7d7e-7589-97eb-f1294a9fe1fc.webp",
      "image_media": {
        "alt_text": "Covered outdoor seating area with sofas, chairs, and a TV.",
        "public_id": "019cfb3c-7d7e-7589-97eb-f1294a9fe1fc",
        "storage_key": "property/6767906449165596/019cfb3c-7d7e-7589-97eb-f1294a9fe1fc.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge, complete with comfortable seating and entertainment.",
      "link": "",
      "alt_text": "Covered outdoor seating area with sofas, chairs, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304497%20(1).JPG"
    },
    {
      "id": "custom_c363124c-0918-4924-b39d-7bda7edb896f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-7e28-71c6-83c6-a1df521ddc5b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, white countertops, stainless steel appliances, and a large island with bar stools.",
        "public_id": "019cfb3c-7e28-71c6-83c6-a1df521ddc5b",
        "storage_key": "property/6767906449165596/019cfb3c-7e28-71c6-83c6-a1df521ddc5b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek dark cabinetry, elegant white countertops, and a generous island perfect for casual dining or entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, white countertops, stainless steel appliances, and a large island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304372%20(1).JPG"
    },
    {
      "id": "custom_2f0968ef-a496-4be8-bed7-2ea11af6e655",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-7e43-77f9-85de-3e1456a68986.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of a furnished apartment with a green sofa, coffee table, and breakfast bar.",
        "public_id": "019cfb3c-7e43-77f9-85de-3e1456a68986",
        "storage_key": "property/6767906449165596/019cfb3c-7e43-77f9-85de-3e1456a68986.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room and open-concept kitchen featuring a breakfast bar with plush stools, a comfortable green sofa, and modern decor.",
      "link": "",
      "alt_text": "Living room and kitchen area of a furnished apartment with a green sofa, coffee table, and breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304767%20(1).JPG"
    },
    {
      "id": "custom_ea466f5c-2417-4979-b2bc-7fa7e43da603",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-80df-7569-87a7-c9f827ddd9d7.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and view of bedroom.",
        "public_id": "019cfb3c-80df-7569-87a7-c9f827ddd9d7",
        "storage_key": "property/6767906449165596/019cfb3c-80df-7569-87a7-c9f827ddd9d7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area with a modern fireplace and a large TV, offering a view into the cozy bedroom.",
      "link": "",
      "alt_text": "Living room with fireplace and view of bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304777%20(1).JPG"
    },
    {
      "id": "custom_475021ac-60d2-4722-9c19-ec594ad905bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-82cc-74bb-be63-4eec40115ee3.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, dark wood furniture, and a ceiling fan.",
        "public_id": "019cfb3c-82cc-74bb-be63-4eec40115ee3",
        "storage_key": "property/6767906449165596/019cfb3c-82cc-74bb-be63-4eec40115ee3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and elegantly designed bedroom featuring a comfortable king-size bed, ample storage with a dresser, and a ceiling fan for added comfort. Perfect for relaxation.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, dark wood furniture, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304627%20(1).JPG"
    },
    {
      "id": "custom_a48e2d2b-e5c2-4b32-b38e-d245a796e1c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-849b-7352-89fa-6dfa025233ad.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, dresser, and mirror.",
        "public_id": "019cfb3c-849b-7352-89fa-6dfa025233ad",
        "storage_key": "property/6767906449165596/019cfb3c-849b-7352-89fa-6dfa025233ad.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a queen-size bed, ample storage with a dresser, and decorative wall art. Perfect for a restful retreat.",
      "link": "",
      "alt_text": "Bedroom with a large bed, dresser, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304982%20(1).JPG"
    },
    {
      "id": "custom_13c9264b-147e-410f-ba3b-dd4813fa45fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-853f-74a2-b560-15ff40b8878f.webp",
      "image_media": {
        "alt_text": "Interior view of a fitness center with treadmills, an elliptical, and a weight machine.",
        "public_id": "019cfb3c-853f-74a2-b560-15ff40b8878f",
        "storage_key": "property/6767906449165596/019cfb3c-853f-74a2-b560-15ff40b8878f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines and strength training equipment.",
      "link": "",
      "alt_text": "Interior view of a fitness center with treadmills, an elliptical, and a weight machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304557%20(1).JPG"
    },
    {
      "id": "custom_fbe3d96c-4759-45e3-af7e-4a1e457721a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-8635-743c-a4fc-44fd01459fac.webp",
      "image_media": {
        "alt_text": "Stylish living room and dining area with large abstract art and a round table with chairs.",
        "public_id": "019cfb3c-8635-743c-a4fc-44fd01459fac",
        "storage_key": "property/6767906449165596/019cfb3c-8635-743c-a4fc-44fd01459fac.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Expansive living and dining area featuring modern decor, a striking abstract painting, and ample natural light, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Stylish living room and dining area with large abstract art and a round table with chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304807%20(1).JPG"
    },
    {
      "id": "custom_a53c3013-6fae-4059-98d0-1b8b36f46d63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-8735-7188-8701-d9a40fb85398.webp",
      "image_media": {
        "alt_text": "A kitchen with a white island and a refrigerator.",
        "public_id": "019cfb3c-8735-7188-8701-d9a40fb85398",
        "storage_key": "property/6767906449165596/019cfb3c-8735-7188-8701-d9a40fb85398.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A beautifully appointed apartment kitchen featuring dark wood cabinetry, white subway tile backsplash, stainless steel appliances, and a spacious marble-topped island with bar seating.",
      "link": "",
      "alt_text": "A kitchen with a white island and a refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304792%20(1).JPG"
    },
    {
      "id": "custom_4751b8ad-a651-4ce9-8aa4-bb7cbe2035c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-897f-72de-9922-bce6c08ccecd.webp",
      "image_media": {
        "alt_text": "Modern communal lounge with a fireplace, comfortable seating, and large windows.",
        "public_id": "019cfb3c-897f-72de-9922-bce6c08ccecd",
        "storage_key": "property/6767906449165596/019cfb3c-897f-72de-9922-bce6c08ccecd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish communal lounge, featuring a striking fireplace and ample natural light.",
      "link": "",
      "alt_text": "Modern communal lounge with a fireplace, comfortable seating, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304337%20(1).JPG"
    },
    {
      "id": "custom_5ad3d42c-8187-4b25-91ac-116f47d611c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-8b6b-7503-882b-903885866884.webp",
      "image_media": {
        "alt_text": "The leasing office at Crest View Luxury Apartments features a reception desk with computers and chairs in a spacious lobby with large windows and an exit sign.",
        "public_id": "019cfb3c-8b6b-7503-882b-903885866884",
        "storage_key": "property/6767906449165596/019cfb3c-8b6b-7503-882b-903885866884.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to the leasing office at Crest View Luxury Apartments, where our team is ready to assist you. Enjoy our spacious lobby and elegant design.",
      "link": "",
      "alt_text": "The leasing office at Crest View Luxury Apartments features a reception desk with computers and chairs in a spacious lobby with large windows and an exit sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304327%20(1).JPG"
    },
    {
      "id": "custom_34159ee2-8a6e-46c1-b195-6d35e031227f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-8c01-762f-b89e-b01c516078b9.webp",
      "image_media": {
        "alt_text": "A dining room with a table and chairs.",
        "public_id": "019cfb3c-8c01-762f-b89e-b01c516078b9",
        "storage_key": "property/6767906449165596/019cfb3c-8c01-762f-b89e-b01c516078b9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Bright dining area with a round table, four chairs, and ample natural light from large windows.",
      "link": "",
      "alt_text": "A dining room with a table and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304812%20(1).JPG"
    },
    {
      "id": "custom_1c6afcb1-beab-47b6-984c-868f521da2a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-8df0-77ea-b2b9-ea86a351dde8.webp",
      "image_media": {
        "alt_text": "Stylish living room with leather sofa, plush accent chair, and desk area.",
        "public_id": "019cfb3c-8df0-77ea-b2b9-ea86a351dde8",
        "storage_key": "property/6767906449165596/019cfb3c-8df0-77ea-b2b9-ea86a351dde8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room, featuring a spacious leather sofa, a cozy accent chair, and a dedicated workspace.",
      "link": "",
      "alt_text": "Stylish living room with leather sofa, plush accent chair, and desk area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304667%20(1).JPG"
    },
    {
      "id": "custom_95ec8441-3ef6-4eee-8d6d-5eabb0272dab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d07db-e8fb-7553-a578-a190650fb6c9.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dark vanity, marble countertop, and orange shower curtain.",
        "public_id": "019d07db-e8fb-7553-a578-a190650fb6c9",
        "storage_key": "property/6767906449165596/019d07db-e8fb-7553-a578-a190650fb6c9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and stylish bathroom featuring a dark wood vanity, marble countertops, a walk-in shower with a modern curtain, and elegant tile flooring.",
      "link": "",
      "alt_text": "Modern bathroom with dark vanity, marble countertop, and orange shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304726%20(1).JPG"
    },
    {
      "id": "custom_a9558f8a-13bb-4496-aad6-26c40ff00d2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-92b7-745b-bb35-bc393506a6c6.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, bedside tables, a ceiling fan, and a window.",
        "public_id": "019cfb3c-92b7-745b-bb35-bc393506a6c6",
        "storage_key": "property/6767906449165596/019cfb3c-92b7-745b-bb35-bc393506a6c6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom featuring a queen-size bed, ample natural light, and stylish decor. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "A bedroom with a queen-size bed, bedside tables, a ceiling fan, and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304732%20(1).JPG"
    },
    {
      "id": "custom_41a4e2fb-658d-4bb3-aea9-92adb7409c96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-92d8-72be-9c86-66862305a504.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019cfb3c-92d8-72be-9c86-66862305a504",
        "storage_key": "property/6767906449165596/019cfb3c-92d8-72be-9c86-66862305a504.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring dark wood cabinetry, sleek marble countertops, and a full suite of stainless steel appliances, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304712%20(1).JPG"
    },
    {
      "id": "custom_090213da-9342-4440-aec6-b3c4f2af5f6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-9788-742c-9632-8b1a8455f6d9.webp",
      "image_media": {
        "alt_text": "A white bathroom with a toilet, sink, and shower.",
        "public_id": "019cfb3c-9788-742c-9632-8b1a8455f6d9",
        "storage_key": "property/6767906449165596/019cfb3c-9788-742c-9632-8b1a8455f6d9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bathroom, featuring a spacious vanity, modern fixtures, and a serene soaking tub.",
      "link": "",
      "alt_text": "A white bathroom with a toilet, sink, and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304651%20(1).JPG"
    },
    {
      "id": "custom_22511f76-5ac0-451e-af00-14e5ea4502c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-9786-7732-b242-cd400c7b6526.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a dark countertop.",
        "public_id": "019cfb3c-9786-7732-b242-cd400c7b6526",
        "storage_key": "property/6767906449165596/019cfb3c-9786-7732-b242-cd400c7b6526.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Bright and spacious kitchen featuring stainless steel appliances, ample cabinet storage, and a convenient breakfast bar. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a dark countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304577%20(1).JPG"
    },
    {
      "id": "custom_b17412a8-bae9-415c-85c7-952652f01e0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-9f39-7039-adba-578c1fa50058.webp",
      "image_media": {
        "alt_text": "Living room with leather sofa and entertainment center",
        "public_id": "019cfb3c-9f39-7039-adba-578c1fa50058",
        "storage_key": "property/6767906449165596/019cfb3c-9f39-7039-adba-578c1fa50058.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy this spacious living area, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with leather sofa and entertainment center",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304682%20(1).JPG"
    },
    {
      "id": "custom_33c98daf-97a8-4194-80ce-beaac27ba104",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-a24c-71b2-8c96-54d5bdfc543e.webp",
      "image_media": {
        "alt_text": "A kitchen with a white marble island and brown cabinets.",
        "public_id": "019cfb3c-a24c-71b2-8c96-54d5bdfc543e",
        "storage_key": "property/6767906449165596/019cfb3c-a24c-71b2-8c96-54d5bdfc543e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience a chef-inspired kitchen with elegant dark wood cabinets, sleek white subway tile, and beautiful marble countertops, perfect for preparing meals.",
      "link": "",
      "alt_text": "A kitchen with a white marble island and brown cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304702%20(1).JPG"
    },
    {
      "id": "custom_51e700c7-8e21-4368-8103-6786ae2fc704",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-a286-7057-be59-067efd7471e8.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a double vanity, toilet, and bathtub with shower.",
        "public_id": "019cfb3c-a286-7057-be59-067efd7471e8",
        "storage_key": "property/6767906449165596/019cfb3c-a286-7057-be59-067efd7471e8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a spacious double vanity with ample storage, a modern toilet, and a bathtub with a shower, perfect for your daily routines.",
      "link": "",
      "alt_text": "Modern bathroom with a double vanity, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304967%20(1).JPG"
    },
    {
      "id": "custom_5c2f71f9-dd07-4b44-970e-f125c285d296",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-a443-7348-8f45-9023b15d6c66.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and subway tile backsplash.",
        "public_id": "019cfb3c-a443-7348-8f45-9023b15d6c66",
        "storage_key": "property/6767906449165596/019cfb3c-a443-7348-8f45-9023b15d6c66.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Beautifully updated kitchen featuring white shaker cabinets, granite countertops, stainless steel appliances including a microwave, range, and dishwasher. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304927%20(1).JPG"
    },
    {
      "id": "custom_5ebfdb00-f36b-4cab-a602-1490d928411e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d07db-f0c9-72db-b2e0-2654060dc95f.webp",
      "image_media": {
        "alt_text": "Bedroom with a large white bed, dresser, and abstract art.",
        "public_id": "019d07db-f0c9-72db-b2e0-2654060dc95f",
        "storage_key": "property/6767906449165596/019d07db-f0c9-72db-b2e0-2654060dc95f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, a stylish dresser with decorative mirrors, and modern artwork.",
      "link": "",
      "alt_text": "Bedroom with a large white bed, dresser, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/A7304742%20(1).JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_9c600343-514e-4b3c-938e-16d0b0ff97d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2526 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and fried pickles, and the rolls are a highlight. They highlight the fair prices and fun, casual atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-8744-75d1-ad8d-72f20f873f6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-8744-75d1-ad8d-72f20f873f6b",
        "storage_key": "property/6767906449165596/019cfb3d-8744-75d1-ad8d-72f20f873f6b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/kansas/wichita-n-greenwich-rd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=1637772610376225648&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "37.7278459",
      "poi_longitude": "-97.2071071",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-634-1106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_-1abr9uocRcNNWCIOJuhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_666c940c-36e9-4d23-b403-4e6d37fc1724",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Topgolf Wichita",
      "poi_type": "Restaurants",
      "poi_address": "2976 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers fun games and a variety of food and drinks. They also highlight the upbeat atmosphere and friendly staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-868e-7422-8e13-6557f9f27b23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-868e-7422-8e13-6557f9f27b23",
        "storage_key": "property/6767906449165596/019cfb3d-868e-7422-8e13-6557f9f27b23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://topgolf.com/us/wichita/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3659202844621293977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-wichita",
      "poi_latitude": "37.7368549",
      "poi_longitude": "-97.2071488",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-394-4065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGUU5Coj9uocRmUnAkpkZyDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_889dff8a-92e6-45e5-ae72-a2a0dd06b26a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Wichita",
      "poi_type": "Restaurants",
      "poi_address": "1240 N Greenwich Rd, Wichita, KS 67206, USA",
      "poi_short_description": "Family-friendly, game joint known for rotisserie chicken, pickleball courts and yard games.",
      "poi_long_description": "People say this restaurant offers a variety of fun outdoor games, pickleball courts, and a spacious indoor area with TVs and a bar. They also highlight the fun and energetic atmosphere, and the friendly staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-54b2-776d-bdee-aeaeeedacc8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-54b2-776d-bdee-aeaeeedacc8a",
        "storage_key": "property/6767906449165596/019cfb3d-54b2-776d-bdee-aeaeeedacc8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/wichita/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3640495953640467354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicken-n-pickle---wichita",
      "poi_latitude": "37.70694599999999",
      "poi_longitude": "-97.205714",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-535-7150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1ZsOYJL9uocRmqv8GsijhTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0aca105d-4601-43d7-b58d-f2655b16fd19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2400 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves good chicken sandwiches and waffle fries. They also highlight the quick service and friendly staff.\n\nOther reviews mention the drive-thru can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-54aa-7196-b95b-bc5406451deb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-54aa-7196-b95b-bc5406451deb",
        "storage_key": "property/6767906449165596/019cfb3d-54aa-7196-b95b-bc5406451deb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ks/k96-greenwich-rd-ks?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4809767043547304648&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "37.726752",
      "poi_longitude": "-97.207335",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-369-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJre8SHCP9uocRyJIEk6S5v0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_9585afe9-af7d-439d-82f3-2f04fecee5a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Towne East Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "7700 E Kellogg Dr, Wichita, KS 67207, USA",
      "poi_short_description": "Big mall with a classic range of department stores, specialty boutiques & kiosks, plus a food court.",
      "poi_long_description": "People say this shopping center offers a wide selection of clothes, shoes, and sporting goods, and has a good food court. They also highlight the clean and safe environment, and the fun atmosphere.\n\nOther reviews mention the games can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-545c-766e-81ca-ad3a887d897c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-545c-766e-81ca-ad3a887d897c",
        "storage_key": "property/6767906449165596/019cfb3d-545c-766e-81ca-ad3a887d897c.webp",
        "width": 550,
        "height": 366
      },
      "poi_business_url": "https://www.simon.com/mall/towne-east-square",
      "poi_directions_map_url": "https://maps.google.com/?cid=15194517817475507784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "towne-east-square",
      "poi_latitude": "37.6832262",
      "poi_longitude": "-97.2469947",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-686-3341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-678d-722f-9d30-c6dd7b075708",
        "storage_key": "property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZfKSnrz8uocRSKb4c3PF3dI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_78721d06-2d05-41d3-aa5a-33e57ecb7c66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1423 N Webb Rd Ste 101, Wichita, KS 67206, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh, organic produce, meat, and prepackaged goods, as well as a bakery, prepared foods, and a coffee shop. They also highlight the clean, organized layout, the friendly and helpful staff, and the convenient Amazon returns.\n\nOther reviews mention the store can be understocked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-5476-760e-86a5-92ad569f08cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-5476-760e-86a5-92ad569f08cf",
        "storage_key": "property/6767906449165596/019cfb3d-5476-760e-86a5-92ad569f08cf.webp",
        "width": 1280,
        "height": 934
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/wichita?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=11170048129198724117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "37.7089215",
      "poi_longitude": "-97.227764",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-630-8484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a9-761a-9fff-62d813e645f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a9-761a-9fff-62d813e645f6",
        "storage_key": "property/6767906449165596/019cfb3d-67a9-761a-9fff-62d813e645f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaVf9R_n8uocRFRTokJf7A5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d5f66fb7-bc81-4542-8ba1-50eef5b041c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1800 N Rock Rd Ste 120, Wichita, KS 67206, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, unique snacks, and beautiful flowers. They highlight the affordable prices and the clean, well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-5644-746a-9b66-93ed85e54ba4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-5644-746a-9b66-93ed85e54ba4",
        "storage_key": "property/6767906449165596/019cfb3d-5644-746a-9b66-93ed85e54ba4.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/ks/wichita/729/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15564502814785791359&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "37.7163031",
      "poi_longitude": "-97.2434865",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-634-1846",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a9-761a-9fff-62d813e645f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a9-761a-9fff-62d813e645f6",
        "storage_key": "property/6767906449165596/019cfb3d-67a9-761a-9fff-62d813e645f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaX4mJJL9uocRf-XfhNg4ANg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c1acdbe8-ad79-4f10-825c-dda68adc2f0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "3250 N Toben St, Wichita, KS 67226, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products at reasonable prices, including construction supplies, and is a great place for DIY projects. They also highlight the helpful staff and convenient pick-up option.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-5528-720e-b5d3-f938c9203216.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-5528-720e-b5d3-f938c9203216",
        "storage_key": "property/6767906449165596/019cfb3d-5528-720e-b5d3-f938c9203216.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3275&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6112294342705808708&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "37.743853",
      "poi_longitude": "-97.230225",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-630-8307",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-678d-722f-9d30-c6dd7b075708",
        "storage_key": "property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJB4oMUXD9uocRRAWcA1I701Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_a60eaee8-6938-4e83-ac11-e6a3d64dd1d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3350 N Woodlawn St, Wichita, KS 67220, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of home items, including paint, and has helpful and friendly staff. They also highlight the competitive prices and good sales.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-55b7-758e-8488-98fa1d1561d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-55b7-758e-8488-98fa1d1561d6",
        "storage_key": "property/6767906449165596/019cfb3d-55b7-758e-8488-98fa1d1561d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/East-Wichita/KS/Wichita/67220/2204?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10636944138880415122&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "37.7443293",
      "poi_longitude": "-97.2612274",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-681-0899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-678d-722f-9d30-c6dd7b075708",
        "storage_key": "property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf_RUnE39uocRkvWjXVYEnpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_c470081b-461f-43df-b59b-349641743ec0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Wichita State University",
      "poi_type": "Education",
      "poi_address": "1845 Fairmount St, Wichita, KS 67260, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.wichita.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2193094869087118587&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-state-university",
      "poi_latitude": "37.7190782",
      "poi_longitude": "-97.291526",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 316-978-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-b9b6411e6121",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSYDXm-niuocR-2Sr9ilwbx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ae44e847-a622-4a51-8408-5083c91b91f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Butler Community College of Andover",
      "poi_type": "Education",
      "poi_address": "5000 Building, 715 E 13th St Room 5012, Andover, KS 67002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-887c-723f-8b91-ff4548e81437.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-887c-723f-8b91-ff4548e81437",
        "storage_key": "property/6767906449165596/019cfb3d-887c-723f-8b91-ff4548e81437.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.butlercc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8602806853151487120&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "butler-community-college-of-andover",
      "poi_latitude": "37.7074517",
      "poi_longitude": "-97.1275701",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-321-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-b9b6411e6121",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_X9HUBr_uocRkPRj2UBPY3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f41a1df6-bab0-45e8-a3ef-46b32026be02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "WSU Tech | National Center for Aviation Training (NCAT)",
      "poi_type": "Education",
      "poi_address": "4004 N Webb Rd, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-8825-716b-b6d6-3afd478ca30f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-8825-716b-b6d6-3afd478ca30f",
        "storage_key": "property/6767906449165596/019cfb3d-8825-716b-b6d6-3afd478ca30f.webp",
        "width": 639,
        "height": 359
      },
      "poi_business_url": "https://wsutech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12806940655175411833&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wsu-tech--national-center-for-aviation-training-ncat",
      "poi_latitude": "37.756972",
      "poi_longitude": "-97.2242927",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-677-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-b9b6411e6121",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA-DVNYACu4cReSg9-6tku7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_603b8ca1-581c-4db6-bff5-595f66877be8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Woolsey Hall",
      "poi_type": "Education",
      "poi_address": "Student Wellness Center Steve Clark YMCA 2060 N Mid-Campus Drive, Wichita, KS 67208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-885a-76c8-a342-edb81655ffbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-885a-76c8-a342-edb81655ffbb",
        "storage_key": "property/6767906449165596/019cfb3d-885a-76c8-a342-edb81655ffbb.webp",
        "width": 1280,
        "height": 906
      },
      "poi_business_url": "https://www.wichita.edu/academics/business/woolsey_hall_2022.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=8990881046444541568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woolsey-hall",
      "poi_latitude": "37.7186727",
      "poi_longitude": "-97.2882013",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-978-4792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-b9b6411e6121",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-e46vvTjuocRgIYeD60Gxnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8e3bdafe-da67-4628-8ea6-98bf1103a687",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Kansas Aviation Museum",
      "poi_type": "Entertainment",
      "poi_address": "3350 George Washington Blvd, Wichita, KS 67210, USA",
      "poi_short_description": "Formerly a municipal airport, with the art deco terminal now housing a tribute to aviation history.",
      "poi_long_description": "Visitors say this museum offers a fascinating look at aviation history, with exhibits on planes, music, and candles. They also highlight the friendly and knowledgeable staff, and the beautiful art deco building and control tower.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-5918-71c6-8b68-762d45905c68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-5918-71c6-8b68-762d45905c68",
        "storage_key": "property/6767906449165596/019cfb3d-5918-71c6-8b68-762d45905c68.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.kansasaviationmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11974673674624859714&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kansas-aviation-museum",
      "poi_latitude": "37.632177",
      "poi_longitude": "-97.2736988",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-683-9242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-6799-71b8-ab1d-9ce154612ba7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-6799-71b8-ab1d-9ce154612ba7",
        "storage_key": "property/6767906449165596/019cfb3d-6799-71b8-ab1d-9ce154612ba7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJnxDQKNfkuocRQn48NUOWLqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d8821556-dbde-4c7a-a7f9-47e41f543e0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Frank Lloyd Wright's Allen House",
      "poi_type": "Entertainment",
      "poi_address": "255 N Roosevelt St, Wichita, KS 67208, USA",
      "poi_short_description": "Guided tours through the period interiors of a 1918 Prairie-style home by Frank Lloyd Wright.",
      "poi_long_description": "People say this museum offers an amazing presentation of architecture and a fascinating guided tour. They highlight the historical significance of the house and the knowledgeable docents. They also like the friendly and entertaining tour guides. ",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://flwrightwichita.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14152560708377734465&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "frank-lloyd-wrights-allen-house",
      "poi_latitude": "37.6897888",
      "poi_longitude": "-97.2924084",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-687-1027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-6799-71b8-ab1d-9ce154612ba7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-6799-71b8-ab1d-9ce154612ba7",
        "storage_key": "property/6767906449165596/019cfb3d-6799-71b8-ab1d-9ce154612ba7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmx3qVRPjuocRQW0BFfv-Z8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ee3d0a29-8b77-4172-8ac5-c4b5c9099116",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Eck Stadium - Tyler Field",
      "poi_type": "Entertainment",
      "poi_address": "4100 E 21st St N, Wichita, KS 67208, USA",
      "poi_short_description": "Cozy venue with outfield benches and other seating for college baseball games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-8967-776e-a6f5-408a8190a509.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-8967-776e-a6f5-408a8190a509",
        "storage_key": "property/6767906449165596/019cfb3d-8967-776e-a6f5-408a8190a509.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://goshockers.com/sports/2015/5/26/Eck_Stadium.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16739415824998152798&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eck-stadium---tyler-field",
      "poi_latitude": "37.721554",
      "poi_longitude": "-97.2889522",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-978-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-679e-74b9-a19c-9cb66d271435.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-679e-74b9-a19c-9cb66d271435",
        "storage_key": "property/6767906449165596/019cfb3d-679e-74b9-a19c-9cb66d271435.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFcCoDOjiuocRXjqR7ABaTug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_7787312b-125e-4e87-a574-357c23a2107c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "The Original Pizza Hut Museum",
      "poi_type": "Entertainment",
      "poi_address": "r ml n, 2090 Innovation Blvd, Wichita, KS 67208, USA",
      "poi_short_description": "Plaque-filled museum for the restaurant chain (founded there) featuring memorabilia and old videos of commercials.",
      "poi_long_description": "People say this museum offers a glimpse into the history of Pizza Hut and showcases cool artifacts. They also highlight the free admission, convenient parking, and nostalgic vibe.\n\nOther reviews mention the museum can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-89e6-701f-bff0-157a84cbaf5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-89e6-701f-bff0-157a84cbaf5e",
        "storage_key": "property/6767906449165596/019cfb3d-89e6-701f-bff0-157a84cbaf5e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wichita.edu/PizzaHutMuseum",
      "poi_directions_map_url": "https://maps.google.com/?cid=1251046177100406038&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-original-pizza-hut-museum",
      "poi_latitude": "37.721033",
      "poi_longitude": "-97.2866173",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-978-4488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-6799-71b8-ab1d-9ce154612ba7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-6799-71b8-ab1d-9ce154612ba7",
        "storage_key": "property/6767906449165596/019cfb3d-6799-71b8-ab1d-9ce154612ba7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6rbuebiuocRFh2up96bXBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f440fb77-00d4-4e87-a646-df370c65d14f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Wilkins Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Wichita, KS 67208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-88d7-727b-bd3e-e0822b82a1fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-88d7-727b-bd3e-e0822b82a1fc",
        "storage_key": "property/6767906449165596/019cfb3d-88d7-727b-bd3e-e0822b82a1fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.goshockers.com/sports/2015/5/26/Wilkins_Softball_Complex.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=17377579020624906431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wilkins-stadium",
      "poi_latitude": "37.7204684",
      "poi_longitude": "-97.2903252",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-978-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-679e-74b9-a19c-9cb66d271435.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-679e-74b9-a19c-9cb66d271435",
        "storage_key": "property/6767906449165596/019cfb3d-679e-74b9-a19c-9cb66d271435.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU9vzO-biuocRv8ighAyQKfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_9b70bdc9-a142-4ed0-9f00-104ffedb862b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6592 E Central Ave, Wichita, KS 67206, USA",
      "poi_short_description": "Chain gym offering a variety of workout equipment, as well as tanning beds, and massage.",
      "poi_long_description": "People say this gym offers a variety of well-maintained equipment. They also highlight the clean environment and friendly, helpful staff.\n\nOther reviews mention the temperature can be uncomfortable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-8b00-7336-8a19-cde37a49682f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-8b00-7336-8a19-cde37a49682f",
        "storage_key": "property/6767906449165596/019cfb3d-8b00-7336-8a19-cde37a49682f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/wichita-normandie-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9254476514064462165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "37.6943986",
      "poi_longitude": "-97.2598706",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-719-3860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2NSzsv8uocRVfEBc1uBboA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fbf87e10-49e2-4587-9114-7e5f9f7246c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Rock Road",
      "poi_type": "Health and Wellness",
      "poi_address": "1551 N Rock Rd, Wichita, KS 67206, USA",
      "poi_short_description": "State-of-the-art fitness center chain outlet in Wichita, Kansas, offering a variety of workout options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-5c54-7169-ba76-594f6dc280b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-5c54-7169-ba76-594f6dc280b2",
        "storage_key": "property/6767906449165596/019cfb3d-5c54-7169-ba76-594f6dc280b2.webp",
        "width": 862,
        "height": 485
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/rock-road.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14856835678487964422&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---rock-road",
      "poi_latitude": "37.7117118",
      "poi_longitude": "-97.245851",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-634-0094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMdkopd_8uocRBuufrlUVLs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c00d4a64-2ec6-4439-b205-9ca78d75bfc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - East Harry",
      "poi_type": "Health and Wellness",
      "poi_address": "1607 S Georgetown St, Wichita, KS 67218, USA",
      "poi_short_description": "Spacious fitness center with a swimming pool and a sauna that focuses on helping members reach their goals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-5cc6-7492-8800-7a4e4db3a881.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-5cc6-7492-8800-7a4e4db3a881",
        "storage_key": "property/6767906449165596/019cfb3d-5cc6-7492-8800-7a4e4db3a881.webp",
        "width": 715,
        "height": 488
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/east-harry.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=8289705737227987081&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---east-harry",
      "poi_latitude": "37.6632431",
      "poi_longitude": "-97.2865009",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-768-8121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI6YqvsfluocRiej9f3LzCnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6ec140af-1141-4b50-86f1-51e7e8ab5c5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - East Central",
      "poi_type": "Health and Wellness",
      "poi_address": "6100 E Central Ave, Wichita, KS 67208, USA",
      "poi_short_description": "Gym, yoga spot, and fitness center featuring cardio equipment, weight machines and free weights, plus 1-on-1 training.",
      "poi_long_description": "People say this gym offers a wide variety of new and updated equipment, as well as recovery amenities like hydro chairs, a sauna, and a jacuzzi. They also highlight the friendly, helpful, and supportive staff, and the unique, retro vibe with neon lighting.\n\nOther reviews mention the gym can be hot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-8bea-700b-946a-c5d471f7031a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-8bea-700b-946a-c5d471f7031a",
        "storage_key": "property/6767906449165596/019cfb3d-8bea-700b-946a-c5d471f7031a.webp",
        "width": 1280,
        "height": 837
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/east-central.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=16504592488182224350&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---east-central",
      "poi_latitude": "37.6952972",
      "poi_longitude": "-97.2664031",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-681-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm4G50TTjuocR3pWuRGwXDOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_854723ef-157a-4913-afc9-a5fe2bf1a04c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Prime Time Barber Shop East Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "505 S Woodlawn St, Wichita, KS 67207, USA",
      "poi_short_description": "Barbershop offering haircuts with appointments recommended.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://getsquire.com/booking/book/prime-time-barbershop-east-wichita",
      "poi_directions_map_url": "https://maps.google.com/?cid=12886161975853718998&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "prime-time-barber-shop-east-wichita",
      "poi_latitude": "37.6789511",
      "poi_longitude": "-97.2626463",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-400-5697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9AOcbL9uocR1h3oEAvY1LI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_6008ceda-e0b6-4d59-a77a-32b6b2063530",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Classy Nails and Spa Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "2413 N Greenwich Rd Ste 111, Wichita, KS 67226, USA",
      "poi_short_description": "Clean nail salon offering gel manicures and pedis as well as eyelash extensions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-5da9-77ea-b9ea-5dc35e075007.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-5da9-77ea-b9ea-5dc35e075007",
        "storage_key": "property/6767906449165596/019cfb3d-5da9-77ea-b9ea-5dc35e075007.webp",
        "width": 1096,
        "height": 841
      },
      "poi_business_url": "http://classynailsspawichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5720972690523935251&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "classy-nails-and-spa-wichita",
      "poi_latitude": "37.7267288",
      "poi_longitude": "-97.2087584",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-977-8864",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzwYliLD9uocRE9Jj3Fn6ZE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_d3a02240-c5cd-4d3e-bbe6-99b9dcfcd357",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "UrgentPet Care",
      "poi_type": "Health and Wellness",
      "poi_address": "11110 E 26th St N Suite 600, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-8ced-773d-81d8-3a8ba5930e97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-8ced-773d-81d8-3a8ba5930e97",
        "storage_key": "property/6767906449165596/019cfb3d-8ced-773d-81d8-3a8ba5930e97.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://urgentpetvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10243324419205437497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urgentpet-care",
      "poi_latitude": "37.7331206",
      "poi_longitude": "-97.2090998",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-440-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoSvzoXb9uocRORjTrUmZJ44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_8727a705-584f-48b4-8bff-72a6cbaaac3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "2240 N Rock Rd Ste 105, Wichita, KS 67226, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-8d1d-76dd-82cd-1c403d032bf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-8d1d-76dd-82cd-1c403d032bf6",
        "storage_key": "property/6767906449165596/019cfb3d-8d1d-76dd-82cd-1c403d032bf6.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/ks/wichita/2240-n-rock-rd?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=7206197409598942425&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "37.7239676",
      "poi_longitude": "-97.2420689",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-558-5996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh1K2IRj9uocR2Sx8LF2OAWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_559c5334-c589-4fe4-a7b0-6d055e6d71f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "PENTHOUSE NAIL LOUNGE AND SPA",
      "poi_type": "Health and Wellness",
      "poi_address": "8141 E Kellogg Dr Suite 111, Wichita, KS 67207, USA",
      "poi_short_description": "Modern and clean spot specializing in nail care services like manicures and pedicures and acrylics as well as massages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-8d20-760d-9348-0c7095e610a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-8d20-760d-9348-0c7095e610a3",
        "storage_key": "property/6767906449165596/019cfb3d-8d20-760d-9348-0c7095e610a3.webp",
        "width": 1200,
        "height": 1200
      },
      "poi_business_url": "https://penthousenaillounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16238123041444152354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "penthouse-nail-lounge-and-spa",
      "poi_latitude": "37.6783945",
      "poi_longitude": "-97.2403687",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-389-6668",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_pKdH39uocRIkRdeN9mWeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_d449ccfc-a320-4568-bede-52a00c1ec94e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Wesley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "550 N Hillside St Main Entrance, Wichita, KS 67214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-5dda-74ff-810b-d39c36746d6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-5dda-74ff-810b-d39c36746d6b",
        "storage_key": "property/6767906449165596/019cfb3d-5dda-74ff-810b-d39c36746d6b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wesleymc.com/locations/wesley-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17159963175428114376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wesley-medical-center",
      "poi_latitude": "37.6964068",
      "poi_longitude": "-97.2983475",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-962-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-679b-779a-88b1-a728f9149fd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-679b-779a-88b1-a728f9149fd9",
        "storage_key": "property/6767906449165596/019cfb3d-679b-779a-88b1-a728f9149fd9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAxK-0xHjuocRyEctNpdvJO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_964389fc-8a95-423f-b41d-a2f29beb957f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Ascension Via Christi St. Joseph",
      "poi_type": "Health and Wellness",
      "poi_address": "3600 E Harry St, Wichita, KS 67218, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-8d54-717f-8de2-c1e6560a5296.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-8d54-717f-8de2-c1e6560a5296",
        "storage_key": "property/6767906449165596/019cfb3d-8d54-717f-8de2-c1e6560a5296.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/kansas/kswic/wichita-ascension-via-christi-st-joseph?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3485178902984589303&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-via-christi-st-joseph",
      "poi_latitude": "37.6655529",
      "poi_longitude": "-97.293099",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-268-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-679b-779a-88b1-a728f9149fd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-679b-779a-88b1-a728f9149fd9",
        "storage_key": "property/6767906449165596/019cfb3d-679b-779a-88b1-a728f9149fd9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJlflZ053kuocR9_8UO7_XXTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2e1819e1-a122-4ca1-858f-9d7bfaab2e62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Great Plains Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6232 East 29th St N #2200, Wichita, KS 67220, USA",
      "poi_short_description": "Indoor-outdoor facilities designed to educate about the flora & fauna of the Great Plains.",
      "poi_long_description": "People say this nature preserve offers beautiful walking trails, diverse wildlife viewing, and opportunities to connect with nature. They highlight the peaceful and relaxing atmosphere, and the well-maintained trails with informative signage. They also like the friendly people and the availability of benches for observation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-5eac-7794-8a97-30d094c7ace3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-5eac-7794-8a97-30d094c7ace3",
        "storage_key": "property/6767906449165596/019cfb3d-5eac-7794-8a97-30d094c7ace3.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://gpnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16028016397833359637&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-plains-nature-center",
      "poi_latitude": "37.73924",
      "poi_longitude": "-97.263722",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-683-5499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67b1-701c-aa1e-821f15223eba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67b1-701c-aa1e-821f15223eba",
        "storage_key": "property/6767906449165596/019cfb3d-67b1-701c-aa1e-821f15223eba.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvcw5n0z9uocRFVH-Zv7zbt4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_b8ce2f1e-7440-4e00-ac1b-8361ea6cee90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Fairmount Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1647 N Yale Blvd, Wichita, KS 67218, USA",
      "poi_short_description": "Spacious park featuring a playground, a splash fountain and a community center.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Fairmount-Park-37",
      "poi_directions_map_url": "https://maps.google.com/?cid=11580955339775493795&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fairmount-park",
      "poi_latitude": "37.7127054",
      "poi_longitude": "-97.29159",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67b1-701c-aa1e-821f15223eba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67b1-701c-aa1e-821f15223eba",
        "storage_key": "property/6767906449165596/019cfb3d-67b1-701c-aa1e-821f15223eba.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3aE5LuLiuocRo0b74oXRt6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_cd91f39e-a6d3-4efa-a079-c9a7011b6ceb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "L.W. Clapp Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4611 E Harry St, Wichita, KS 67218, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-8e53-742c-a661-190f4968ed6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-8e53-742c-a661-190f4968ed6c",
        "storage_key": "property/6767906449165596/019cfb3d-8e53-742c-a661-190f4968ed6c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/LW-Clapp-Memorial-Park-162",
      "poi_directions_map_url": "https://maps.google.com/?cid=11495452650844501100&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lw-clapp-park",
      "poi_latitude": "37.6623254",
      "poi_longitude": "-97.2828208",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-688-9341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67b1-701c-aa1e-821f15223eba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67b1-701c-aa1e-821f15223eba",
        "storage_key": "property/6767906449165596/019cfb3d-67b1-701c-aa1e-821f15223eba.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa5z3WKLkuocRbLToyUcNiJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_52e74f64-0f4f-4b33-8524-7b0f0adcfb48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Edgemoor Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5815 E 9th St N, Wichita, KS 67208, USA",
      "poi_short_description": "Park featuring a splash pad and skate park along with basketball and tennis courts.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Edgemoor-Park-20",
      "poi_directions_map_url": "https://maps.google.com/?cid=14777509089755302817&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edgemoor-park",
      "poi_latitude": "37.70038470000001",
      "poi_longitude": "-97.2688025",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67b1-701c-aa1e-821f15223eba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67b1-701c-aa1e-821f15223eba",
        "storage_key": "property/6767906449165596/019cfb3d-67b1-701c-aa1e-821f15223eba.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxST4RjLjuocRoYv49zhCFM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_c8b414ef-fb46-4569-a511-8aab7506b7da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "MacDonald Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "840 N Yale Ave, Wichita, KS 67208, USA",
      "poi_short_description": "Public city 18-hole golf course dotted with ponds & mature trees & offering golf carts.",
      "poi_long_description": "Public city 18-hole golf course dotted with ponds & mature trees & offering golf carts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-611a-7558-beef-a93e2f501f35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-611a-7558-beef-a93e2f501f35",
        "storage_key": "property/6767906449165596/019cfb3d-611a-7558-beef-a93e2f501f35.webp",
        "width": 1280,
        "height": 279
      },
      "poi_business_url": "https://www.wichita.gov/facilities/facility/details/MacDonald-Golf-Course-149",
      "poi_directions_map_url": "https://maps.google.com/?cid=12364549608739728143&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "macdonald-golf-course",
      "poi_latitude": "37.6986098",
      "poi_longitude": "-97.2919043",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-688-9391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-6799-71b8-ab1d-a2eb2878229f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-6799-71b8-ab1d-a2eb2878229f",
        "storage_key": "property/6767906449165596/019cfb3d-6799-71b8-ab1d-a2eb2878229f.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJATNFVBjjuocRD2ug5Fu0l6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_31f285f3-30e6-4ee1-8132-e1b86198f4e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Colonel James Jabara Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3512 N Webb Rd, Wichita, KS 67226, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.flywichita.com/general-aviation-jabara/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4247184628307720702&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "colonel-james-jabara-airport",
      "poi_latitude": "37.747501",
      "poi_longitude": "-97.221107",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-636-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-6a86-72e9-8ad5-4cb8275e47c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-6a86-72e9-8ad5-4cb8275e47c6",
        "storage_key": "property/6767906449165596/019cfb3d-6a86-72e9-8ad5-4cb8275e47c6.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QXGMHj9uocR_vnHueoH8To",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_c8a36bde-e821-46db-a539-e17ec318ae27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "United States Department-The Air Force",
      "poi_type": "Transportation & Transit",
      "poi_address": "53280 Topeka St # 221, McConnell AFB, KS 67221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15137253015023024284&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "united-states-department-the-air-force",
      "poi_latitude": "37.6347274",
      "poi_longitude": "-97.2563934",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-864-8331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-6a86-72e9-8ad5-4cb8275e47c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-6a86-72e9-8ad5-4cb8275e47c6",
        "storage_key": "property/6767906449165596/019cfb3d-6a86-72e9-8ad5-4cb8275e47c6.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ98NSryj7uocRnHioo2pTEtI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_f806cd61-280c-410a-8e46-650222d7115b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Beech Factory Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9709 E Central Ave, Wichita, KS 67206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-61d3-7038-807d-d02c47e3b62e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-61d3-7038-807d-d02c47e3b62e",
        "storage_key": "property/6767906449165596/019cfb3d-61d3-7038-807d-d02c47e3b62e.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.beechcraft.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2405539519632020958&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beech-factory-airport",
      "poi_latitude": "37.694119",
      "poi_longitude": "-97.222706",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-6a86-72e9-8ad5-4cb8275e47c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-6a86-72e9-8ad5-4cb8275e47c6",
        "storage_key": "property/6767906449165596/019cfb3d-6a86-72e9-8ad5-4cb8275e47c6.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJL2fuq2D8uocR3pXUsHIxYiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_70ebe818-3592-4933-aa63-7a2722b7b36d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Augusta Municipal Airport - 3AU",
      "poi_type": "Transportation & Transit",
      "poi_address": "4800 W Beech Dr Suite 1, Augusta, KS 67010, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.flyaugustaks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15455407083417197764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "augusta-municipal-airport---3au",
      "poi_latitude": "37.6783128",
      "poi_longitude": "-97.0796761",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-733-1326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-6a86-72e9-8ad5-4cb8275e47c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-6a86-72e9-8ad5-4cb8275e47c6",
        "storage_key": "property/6767906449165596/019cfb3d-6a86-72e9-8ad5-4cb8275e47c6.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJsW_O-ghWuocRxFwjKtuifNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_72f0eaf1-a3de-4c8b-b109-b5ebf49d5f19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Cessna Aircraft Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "7751 E Pawnee St, Wichita, KS 67207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4990377361051433458&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cessna-aircraft-field",
      "poi_latitude": "37.6495235",
      "poi_longitude": "-97.2505854",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-831-4036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-6a86-72e9-8ad5-4cb8275e47c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-6a86-72e9-8ad5-4cb8275e47c6",
        "storage_key": "property/6767906449165596/019cfb3d-6a86-72e9-8ad5-4cb8275e47c6.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJHwjn_MjjuocR8jmfDMVhQUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_410dca96-d352-42ae-bb67-6c5aec4cf4f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Textron Aviation Career & Learning Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "293 S Greenwich Rd Suite 400, Wichita, KS 67206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://txtav.com/en/careers/career-learning-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=17738308330864323395&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "textron-aviation-career--learning-center",
      "poi_latitude": "37.6827328",
      "poi_longitude": "-97.2112662",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-515-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN6sjFQD9uocRQyuFAXIhK_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9e884250-7942-4105-bcce-f43db9d71084",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Airbus Americas Engineering",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1855 Innovation Blvd, Wichita, KS 67208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-91e5-7781-a556-d069725c9bf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-91e5-7781-a556-d069725c9bf6",
        "storage_key": "property/6767906449165596/019cfb3d-91e5-7781-a556-d069725c9bf6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.airbus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2717662062190135635&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airbus-americas-engineering",
      "poi_latitude": "37.717177",
      "poi_longitude": "-97.2864877",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-299-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw6cW5d3iuocRUwlmLD8TtyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_edc4c9c9-9f86-4872-9c1a-f518c3a12a42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Goodwill Industries of Kansas Administration & NexStep Alliance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3351 N Webb Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Long-standing nonprofit chain with a range of pre-owned clothing, furniture, housewares & more.",
      "poi_long_description": "Long-standing nonprofit chain with a range of pre-owned clothing, furniture, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-63b6-75ca-ad0a-53d05fec8dc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-63b6-75ca-ad0a-53d05fec8dc9",
        "storage_key": "property/6767906449165596/019cfb3d-63b6-75ca-ad0a-53d05fec8dc9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://goodwillks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2600486553204831060&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "goodwill-industries-of-kansas-administration--nexstep-alliance",
      "poi_latitude": "37.744572",
      "poi_longitude": "-97.2273",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-744-9291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTXAYzXD9uocRVDP0_r3IFiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3d950d07-f358-49ab-9adb-62db3cfa0623",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "WIC Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1131 S Clifton Ave, Wichita, KS 67218, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.sedgwickcounty.org/health/services-and-providers/women-infants-and-children-wic/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15592591238908059629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wic-office",
      "poi_latitude": "37.6673061",
      "poi_longitude": "-97.2945491",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-660-7444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi5dkX4jluocR7Z_7Yh4DZNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d99c5f22-5f1b-4089-8477-d0eb6ee16b0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Freddy's Frozen Custard - HQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3020 N Cypress Dr Suite 200, Wichita, KS 67226, USA",
      "poi_short_description": "Vintage-style chain for steakburgers, hot dogs & other fast-food staples, plus frozen custard.",
      "poi_long_description": "Vintage-style chain for steakburgers, hot dogs & other fast-food staples, plus frozen custard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-912f-72aa-9c5b-282c3fa59961.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3d-912f-72aa-9c5b-282c3fa59961",
        "storage_key": "property/6767906449165596/019cfb3d-912f-72aa-9c5b-282c3fa59961.webp",
        "width": 600,
        "height": 450
      },
      "poi_business_url": "https://www.freddys.com/?utm_source=gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=13102723026135156589&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "freddys-frozen-custard---hq",
      "poi_latitude": "37.7402941",
      "poi_longitude": "-97.2310622",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-719-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf-eBg5X8uocRbQceyys51rU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ff836cfb-dfd6-4116-a3fc-bb12442cd09d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Bostic Traditional Magnet Elementary School",
      "poi_type": "Education",
      "poi_address": "8103 E Gilbert St, Wichita, KS 67207, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-1c15-779f-828c-c92908cc6dd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1c15-779f-828c-c92908cc6dd3",
        "storage_key": "property/6767906449165596/019d7912-1c15-779f-828c-c92908cc6dd3.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://bostic.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8186633512078039731&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bostic-traditional-magnet-elementary-school",
      "poi_latitude": "37.6751729",
      "poi_longitude": "-97.2408591",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-973-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-b9b6411e6121",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5auM4p78uocRs1q4-c3DnHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_44ef908c-f2bb-42bf-80f4-1351969df175",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Seltzer Elementary School",
      "poi_type": "Education",
      "poi_address": "11660 E Lincoln St, Wichita, KS 67207, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-1c20-7720-bcb9-ff634781aaa6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1c20-7720-bcb9-ff634781aaa6",
        "storage_key": "property/6767906449165596/019d7912-1c20-7720-bcb9-ff634781aaa6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://seltzer.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7552519185368375997&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "seltzer-elementary-school",
      "poi_latitude": "37.6729845",
      "poi_longitude": "-97.2021751",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-973-4001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-b9b6411e6121",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJReHnm4r7uocRvWI0Iy_wz2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b1d6cd77-167c-434f-8ff4-feba5b0c5388",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Andover Central Middle School",
      "poi_type": "Education",
      "poi_address": "903 E Central Ave, Andover, KS 67002, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-1a9c-75de-b725-4e2b78df8a49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1a9c-75de-b725-4e2b78df8a49",
        "storage_key": "property/6767906449165596/019d7912-1a9c-75de-b725-4e2b78df8a49.webp",
        "width": 750,
        "height": 540
      },
      "poi_business_url": "http://acms.usd385.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13194244385255600903&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "andover-central-middle-school",
      "poi_latitude": "37.6927759",
      "poi_longitude": "-97.1242446",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-218-4710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-b9b6411e6121",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0cYqIHD_uocRBzPavlxfG7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5edd0851-8773-4455-9383-554fd6543722",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "The Independent School",
      "poi_type": "Education",
      "poi_address": "8313 E Douglas Ave, Wichita, KS 67207, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-1aa1-752b-9bb9-3c1c3306f690.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1aa1-752b-9bb9-3c1c3306f690",
        "storage_key": "property/6767906449165596/019d7912-1aa1-752b-9bb9-3c1c3306f690.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.theindependentschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15502445811572740481&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-independent-school",
      "poi_latitude": "37.6857509",
      "poi_longitude": "-97.2379803",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-686-0152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-b9b6411e6121",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwTeywJb8uocRgRGJhFTAI9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_77092ee7-24f5-41c3-978e-39223bc6a035",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Wichita Collegiate School",
      "poi_type": "Education",
      "poi_address": "9115 E 13th St N, Wichita, KS 67206, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-21d3-761b-a673-4bd6e01150d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-21d3-761b-a673-4bd6e01150d6",
        "storage_key": "property/6767906449165596/019d7912-21d3-761b-a673-4bd6e01150d6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.wcsks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6161546641279598679&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-collegiate-school",
      "poi_latitude": "37.7070832",
      "poi_longitude": "-97.2314664",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-634-0433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-b9b6411e6121",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-b9b6411e6121.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMeE4GPv8uocRV8B4ZAY2glU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_0041667c-2669-42b0-9021-cf09ed27ea5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Chesters Chophouse & Wine Bar",
      "poi_type": "Restaurants",
      "poi_address": "1550 N Webb Rd, Wichita, KS 67206, USA",
      "poi_short_description": "Polished destination serving a contemporary take on steaks & seafood plus a full bar & cigars.",
      "poi_long_description": "People say this restaurant serves delicious steaks, seafood, and sides, and offers a wide selection of wines and bourbons. They also highlight the fantastic service, beautiful atmosphere, and live music.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-271e-7649-9274-375ff6cc9fff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-271e-7649-9274-375ff6cc9fff",
        "storage_key": "property/6767906449165596/019d7912-271e-7649-9274-375ff6cc9fff.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "http://www.chesterschophouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12814005038622968159&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chesters-chophouse-wine-bar",
      "poi_latitude": "37.711702",
      "poi_longitude": "-97.225617",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-201-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm0sb9_78uocRXwkw7bB91LE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_58444a4d-80a7-4dc2-a6f9-5c6151723bb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "YaYa's Euro Bistro",
      "poi_type": "Restaurants",
      "poi_address": "8115 E 21st St N, Wichita, KS 67206, USA",
      "poi_short_description": "Earthy, elegant restaurant offering European-American fusion fare & fine wines, plus Sunday brunch.",
      "poi_long_description": "People say this bistro offers delicious steak, lasagna, and roast chicken, as well as a popular hummus plate and chocolate soufflé. They also highlight the attentive service, cozy and intimate atmosphere, and the perfect size of the Burgundy room for private parties.\n\nOther reviews mention the food quality can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-264c-7581-a87d-440f940f384b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-264c-7581-a87d-440f940f384b",
        "storage_key": "property/6767906449165596/019d7912-264c-7581-a87d-440f940f384b.webp",
        "width": 550,
        "height": 410
      },
      "poi_business_url": "http://www.yayaswichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2739562055441357035&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "yaya-s-euro-bistro",
      "poi_latitude": "37.7221885",
      "poi_longitude": "-97.2429595",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-634-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzwBvZRj9uocR65i4sizhBCY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bistro"
    },
    {
      "id": "custom_9797e2ce-918a-40e9-b3cb-fd495222f2ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Newport Grill",
      "poi_type": "Restaurants",
      "poi_address": "1900 N Rock Rd, Wichita, KS 67206, USA",
      "poi_short_description": "Seafood-focused grill with an airy, aquatic-themed room & deck seating overlooking a small lake.",
      "poi_long_description": "People say this asador serves delicious seafood, including fresh oysters, scallops, and sea bass, as well as steak and pasta dishes. They highlight the upscale atmosphere, perfect for special occasions, and the beautiful patio seating with a lakeside view. They also like the attentive service and the well-crafted cocktails and mocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-2967-77ae-9dbc-b2ecf2df3a8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2967-77ae-9dbc-b2ecf2df3a8e",
        "storage_key": "property/6767906449165596/019d7912-2967-77ae-9dbc-b2ecf2df3a8e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.newportgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=222403872954958458&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "newport-grill",
      "poi_latitude": "37.7191544",
      "poi_longitude": "-97.2424049",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-636-9555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8vfSx_9uocResIm5CQjFgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_10ecbb39-ae14-43b3-b083-9b8a10dca1fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "First Mile Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "2141 N Bradley Fair Pkwy #111, Wichita, KS 67206, USA",
      "poi_short_description": "Relaxed spot for locally sourced goods featuring wood-fired eats, inventive cocktails, and a wine list.",
      "poi_long_description": "People say this restaurant serves delicious salmon, pork, and lobster deviled eggs. They also highlight the great wine selection, tasty desserts, and the friendly and helpful staff.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-2c1f-7498-99cb-6aa3d0a649ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2c1f-7498-99cb-6aa3d0a649ea",
        "storage_key": "property/6767906449165596/019d7912-2c1f-7498-99cb-6aa3d0a649ea.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.firstmilekitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16753804929406160331&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "first-mile-kitchen",
      "poi_latitude": "37.7221719",
      "poi_longitude": "-97.2421475",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-358-0130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv8HFXq79uocRy01xXdF4geg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a619187d-b75c-4e08-b293-c7ea1039c380",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "10250 E 13th St N, Wichita, KS 67206, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "People say this seafood restaurant serves excellent fish and chips, blackened salmon, and bang bang shrimp. They highlight the great food portions, reasonable prices, and quiet atmosphere. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-2ffd-75e8-a04d-b8a343e6f13e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2ffd-75e8-a04d-b8a343e6f13e",
        "storage_key": "property/6767906449165596/019d7912-2ffd-75e8-a04d-b8a343e6f13e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.bonefishgrill.com/kansas/wichita/10250-e.-13th-street-n.?y_source=1_MTU1MDI3MDgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13716726552427287222&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "37.7095188",
      "poi_longitude": "-97.2201178",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-315-0299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Whkh1b8uocRttKYBiCaW74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_d6081a45-d8e9-4f64-8a48-4615e8c4ecfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "11711 E 13th St N, Wichita, KS 67206, USA",
      "poi_short_description": "Family-friendly chain serving American comfort food with a Texas twist, plus cocktails.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious chicken fried chicken, chicken tender platters, and croissants. They also highlight the friendly and helpful staff, reasonable prices, and generous portions.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-374c-708c-a80f-0a6f3bb092ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-374c-708c-a80f-0a6f3bb092ae",
        "storage_key": "property/6767906449165596/019d7912-374c-708c-a80f-0a6f3bb092ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ks/wichita/wichita/2028?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:wichita-ks-2028_pl:locurl_rd:1023",
      "poi_directions_map_url": "https://maps.google.com/?cid=18440598754995668397&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cheddar-s-scratch-kitchen",
      "poi_latitude": "37.7079934",
      "poi_longitude": "-97.2020766",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-688-0401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_MnSkj8uocRrQUHfd0q6v8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f96fc39d-e157-4e8d-8e99-dd141f892ec6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Jose Pepper's",
      "poi_type": "Restaurants",
      "poi_address": "123 S Santa Fe Ave, Salina, KS 67401, USA",
      "poi_short_description": "Relaxed Mexican chain serving tacos, burritos & other classic dishes, plus margaritas.",
      "poi_long_description": "People say this Tex Mex restaurant serves delicious food, including a must-try spinach dip. They also highlight the attentive staff, quick service, and great value.\n\nOther reviews mention the service can be rushed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-3822-7520-becb-f9cb9fe13a50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3822-7520-becb-f9cb9fe13a50",
        "storage_key": "property/6767906449165596/019d7912-3822-7520-becb-f9cb9fe13a50.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.josepeppers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7256975610526884218&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jose-pepper-s",
      "poi_latitude": "38.8396203",
      "poi_longitude": "-97.6088167",
      "poi_miles_from_property": "94.5 mi",
      "poi_walking_minutes": "1 day 10 hours",
      "poi_biking_minutes": "7 hours 55 mins",
      "poi_driving_minutes": "1 hour 24 mins",
      "poi_business_phone": "+1 785-201-9321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBWv2oTXFvIcReuEgYd70tWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_b8f275fd-0399-4ec1-8a41-68c91c4ccc8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Fusa",
      "poi_type": "Restaurants",
      "poi_address": "303 S Greenwich Rd, Wichita, KS 67207, USA",
      "poi_short_description": "Counter-serve eatery offering an eclectic menu of burgers, burritos, Asian favorites & more.",
      "poi_long_description": "People say this Chinese restaurant serves delicious honey walnut chicken, Singapore noodles, and other dishes. They highlight the decent prices and the clean, niche atmosphere. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-3a77-76a8-ac63-e89f26250ff1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3a77-76a8-ac63-e89f26250ff1",
        "storage_key": "property/6767906449165596/019d7912-3a77-76a8-ac63-e89f26250ff1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fusawichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13434537112512575292&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fusa",
      "poi_latitude": "37.6826383",
      "poi_longitude": "-97.2084921",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-618-1818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRL2bKP8uocRPDcdGVMQcbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_50c7d567-fe93-4b96-982e-b3a3d67281f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Promise | Thai Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "313 S Greenwich Rd, Wichita, KS 67207, USA",
      "poi_short_description": "Thai eatery serving curries, noodles & more in a contemporary space with traditional accents.",
      "poi_long_description": "People say this Thai restaurant serves delicious dishes, including Basil Leaves Chicken, Beef Panang Curry, and Pad Thai. They highlight the food is natural and not overly processed, and the prices are reasonable. They also like the welcoming and helpful owners, and the prompt service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-44c4-703e-99b2-cbf18dfc091d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-44c4-703e-99b2-cbf18dfc091d",
        "storage_key": "property/6767906449165596/019d7912-44c4-703e-99b2-cbf18dfc091d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.facebook.com/PromisethaiCuisine",
      "poi_directions_map_url": "https://maps.google.com/?cid=14584662208922134614&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "promise-thai-cuisine",
      "poi_latitude": "37.6823506",
      "poi_longitude": "-97.2085752",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-440-4555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfanntHH8uocRVijekwEhZ8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_61f9d316-5252-4961-b49d-4456a5bc1ad9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Old Chicago Pizza + Taproom",
      "poi_type": "Restaurants",
      "poi_address": "7626 E Kellogg Dr, Wichita, KS 67207, USA",
      "poi_short_description": "Family-friendly chain restaurant featuring Italian entrees along with a wide beer selection.",
      "poi_long_description": "People say this pizza restaurant serves delicious pizza and wings, and offers a variety of drinks. They also highlight the attentive and friendly staff, and the fun atmosphere with plenty of TVs for watching games.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-4a09-73ce-af1d-1c3062bfae2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4a09-73ce-af1d-1c3062bfae2b",
        "storage_key": "property/6767906449165596/019d7912-4a09-73ce-af1d-1c3062bfae2b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oldchicago.com/locations/us/ks/wichita/7626-east-kellogg-drive/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8189026396054944595&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-chicago-pizza-taproom",
      "poi_latitude": "37.680093",
      "poi_longitude": "-97.248431",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-272-0120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1VbMSaP8uocRU_smsR5EpXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_372c00e1-9a58-4c37-a510-b2a712fd96b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Two Brothers BBQ",
      "poi_type": "Restaurants",
      "poi_address": "300 S Greenwich Rd, Wichita, KS 67207, USA",
      "poi_short_description": "Casual, family-owned eatery for BBQ staples such as ribs, brisket & pulled pork, plus classic sides.",
      "poi_long_description": "People say this barbecue restaurant serves delicious brisket, ribs, and smoked wings. They also highlight the friendly staff, quick service, and generous portions.\n\nOther reviews mention the sides can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-494b-7539-9bd0-a8720bbae526.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-494b-7539-9bd0-a8720bbae526",
        "storage_key": "property/6767906449165596/019d7912-494b-7539-9bd0-a8720bbae526.webp",
        "width": 576,
        "height": 296
      },
      "poi_business_url": "http://www.twobrothersbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14483101316205276911&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "two-brothers-bbq",
      "poi_latitude": "37.6827589",
      "poi_longitude": "-97.2075083",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-683-1330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoaNKvnH8uocR725ojulP_sg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_1229e6f1-842b-48a0-b88a-99b9e233e073",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "10800 E 21st St N, Wichita, KS 67206, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store has a wide selection of products. They also highlight the kind and courteous employees, and the minimal checkout time.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-4f40-7378-845e-40b909c2eea4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4f40-7378-845e-40b909c2eea4",
        "storage_key": "property/6767906449165596/019d7912-4f40-7378-845e-40b909c2eea4.webp",
        "width": 1140,
        "height": 749
      },
      "poi_business_url": "https://www.target.com/sl/wichita-ne/1944",
      "poi_directions_map_url": "https://maps.google.com/?cid=6067598449320791704&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "37.724525",
      "poi_longitude": "-97.2123712",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-636-4206",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-678d-722f-9d30-c6dd7b075708",
        "storage_key": "property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJazbbMa79uocRmA56Y6RwNFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_e41afdb4-3ff2-47f4-be40-d6d082602b3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "11959 E Kellogg Dr, Wichita, KS 67207, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide selection of products and is well-stocked. They also highlight the helpful and friendly staff, and the clean store.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-517c-7688-b5a0-2e846978420f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-517c-7688-b5a0-2e846978420f",
        "storage_key": "property/6767906449165596/019d7912-517c-7688-b5a0-2e846978420f.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/KS-Wichita/1547?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1547-_-na-_-0-_-0&y_source=1_MTE4MzEwMy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16334796848679276618&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lowe-s-home-improvement",
      "poi_latitude": "37.6768062",
      "poi_longitude": "-97.1985276",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-684-3117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-678d-722f-9d30-c6dd7b075708",
        "storage_key": "property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYRHlGwv8uocRStCyOzDbsOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_0f6fe118-bb84-48c8-b8cc-a9a7c0f85065",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "11739 E Kellogg Dr, Wichita, KS 67207, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-5ad1-743e-9195-2482880b96db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5ad1-743e-9195-2482880b96db",
        "storage_key": "property/6767906449165596/019d7912-5ad1-743e-9195-2482880b96db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.petsmart.com/stores/us/ks/wichita-store2370.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=11798334574296937533&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "37.6770563",
      "poi_longitude": "-97.2014871",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-361-5174",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-678d-722f-9d30-c6dd7b075708",
        "storage_key": "property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJD8iCoHT8uocRPbQt-sgavKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_3f71a29b-8810-4d6b-b50a-17ecc7c32ac5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "9700 E Kellogg Dr, Wichita, KS 67207, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "People say this warehouse store offers a wide variety of products, including groceries, household goods, clothing, and tires. They highlight the great value, with many items available in bulk and at competitive prices, and the clean, well-organized layout. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-5b8a-71dc-95ee-5171c3257541.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5b8a-71dc-95ee-5171c3257541",
        "storage_key": "property/6767906449165596/019d7912-5b8a-71dc-95ee-5171c3257541.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/wichita-KS-1200.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10259352436359460336&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "37.6802342",
      "poi_longitude": "-97.2237745",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-226-7142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-678d-722f-9d30-c6dd7b075708",
        "storage_key": "property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE-QgDYf8uocR8HW-Oq-KYI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_475d9a92-0218-4996-9c8a-404088a1aaa0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "1920 N Rock Rd, Wichita, KS 67206, USA",
      "poi_short_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_long_description": "People say this bookstore offers a wide selection of books, vinyl records, and other items, as well as coffee and condiments. They highlight the great location and the cozy, welcoming atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-5873-756a-acf2-1e28ae08fccc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5873-756a-acf2-1e28ae08fccc",
        "storage_key": "property/6767906449165596/019d7912-5873-756a-acf2-1e28ae08fccc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2319",
      "poi_directions_map_url": "https://maps.google.com/?cid=1492793780422762160&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "barnes-noble",
      "poi_latitude": "37.71837",
      "poi_longitude": "-97.243961",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-315-0421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-678d-722f-9d30-c6dd7b075708",
        "storage_key": "property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1UbFMCD9uocRsN4CvQh4txQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_f0a9c108-9494-440b-90e8-8bb2c5723d86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2111 N Rock Rd Suite 121, Wichita, KS 67206, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "People say this electronics store offers a wide selection of laptops, cellphones, televisions, and other electronics. They also highlight the helpful and knowledgeable staff, and the smooth online ordering and pickup process.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-5cc2-704e-b1d7-3278b50bbf1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5cc2-704e-b1d7-3278b50bbf1e",
        "storage_key": "property/6767906449165596/019d7912-5cc2-704e-b1d7-3278b50bbf1e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/ks/wichita/2111-north-rock-rd-51.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=13372378113611161734&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "37.7217913",
      "poi_longitude": "-97.2467812",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-684-5026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-678d-722f-9d30-c6dd7b075708",
        "storage_key": "property/6767906449165596/019cfb3d-678d-722f-9d30-c6dd7b075708.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhf6V_CL9uocRhmAAYAs7lLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_4bea7593-0661-4e02-9820-a1caa65ae396",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Regal Warren East",
      "poi_type": "Entertainment",
      "poi_address": "11611 E 13th St N, Wichita, KS 67206, USA",
      "poi_short_description": "Retro-style multiplex chain showing new releases; some locations feature '40s-style diners & IMAX.",
      "poi_long_description": "People say this movie theater offers comfortable reclining seats, a great selection of movies, and delicious popcorn. They also highlight the friendly staff, clean facilities, and convenient online ticket purchase.\n\nSome reviews mention the concession prices can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-68a7-775d-a74f-b211f2ae90a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-68a7-775d-a74f-b211f2ae90a0",
        "storage_key": "property/6767906449165596/019d7912-68a7-775d-a74f-b211f2ae90a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-warren-east-1444?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9651335916542880804&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "regal-warren-east",
      "poi_latitude": "37.70566",
      "poi_longitude": "-97.202705",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-9b0b-751b-8317-5f3f68d92295.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-9b0b-751b-8317-5f3f68d92295",
        "storage_key": "property/6767906449165596/019d7912-9b0b-751b-8317-5f3f68d92295.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJYXl2EVT9uocRJOyBkeFu8IU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_e2c8cb4c-e5ba-4ef7-bf84-fb933d6dd03d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "W.B. Harrison Park",
      "poi_type": "Entertainment",
      "poi_address": "1300 S Webb Rd, Wichita, KS 67207, USA",
      "poi_short_description": "Recreation destination featuring a large dog park, sports fields, a playground, fitness equipment, and a pond.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-6fcd-763a-a2eb-ee976e93cdaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6fcd-763a-a2eb-ee976e93cdaa",
        "storage_key": "property/6767906449165596/019d7912-6fcd-763a-a2eb-ee976e93cdaa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/WB-Harrison-Park-14",
      "poi_directions_map_url": "https://maps.google.com/?cid=12747109057262009754&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "w-b-harrison-park",
      "poi_latitude": "37.6683767",
      "poi_longitude": "-97.2192732",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67b1-701c-aa1e-821f15223eba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67b1-701c-aa1e-821f15223eba",
        "storage_key": "property/6767906449165596/019cfb3d-67b1-701c-aa1e-821f15223eba.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJU4uAW3_7uocRmj1EhybU5rA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_e0e73ba8-497f-4799-a9e6-b9439e057d6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Wichita Sports Forum",
      "poi_type": "Entertainment",
      "poi_address": "2668 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Trampoline area with several foam pits, plus sand volleyball, basketball and soccer courts.",
      "poi_long_description": "People say this sports complex offers a variety of activities, including basketball, volleyball, and a trampoline park. They also highlight the fun atmosphere and the friendly, helpful staff.\n\nSome reviews mention the facilities can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-6d37-72c1-a8df-cedf978949ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6d37-72c1-a8df-cedf978949ad",
        "storage_key": "property/6767906449165596/019d7912-6d37-72c1-a8df-cedf978949ad.webp",
        "width": 1280,
        "height": 457
      },
      "poi_business_url": "http://wichitasportsforum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=290413582065142880&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-sports-forum",
      "poi_latitude": "37.7324621",
      "poi_longitude": "-97.1999983",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-201-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4bsAl7v9uocRYAzxPJ3BBwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_e05691f5-4dce-43e2-a7b2-1d8d6f362c67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Dave & Buster's Wichita",
      "poi_type": "Entertainment",
      "poi_address": "2644 N Greenwich Ct, Wichita, KS 67226, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "People say this restaurant offers a wide variety of games and virtual reality experiences, making it a fun place for kids and adults. They also highlight the friendly staff and the fun, lively atmosphere, especially for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-7b8e-7348-937c-77cd709b1ac2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7b8e-7348-937c-77cd709b1ac2",
        "storage_key": "property/6767906449165596/019d7912-7b8e-7348-937c-77cd709b1ac2.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/wichita",
      "poi_directions_map_url": "https://maps.google.com/?cid=7654772984293764890&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dave-buster-s-wichita",
      "poi_latitude": "37.7301016",
      "poi_longitude": "-97.2016028",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-796-8550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67ab-706d-8d03-bd657fbe3b78",
        "storage_key": "property/6767906449165596/019cfb3d-67ab-706d-8d03-bd657fbe3b78.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVR9GjIL9uocRGi8W9Xg3O2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f5b5f107-d93b-46ec-9c27-428b6d05c444",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Mark Arts",
      "poi_type": "Entertainment",
      "poi_address": "1307 N Rock Rd, Wichita, KS 67206, USA",
      "poi_short_description": "Vibrant arts center featuring exhibits, classes, and special events, plus a gender-neutral restroom.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-77e0-7591-887f-950bbb740daf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-77e0-7591-887f-950bbb740daf",
        "storage_key": "property/6767906449165596/019d7912-77e0-7591-887f-950bbb740daf.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "http://markartsks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15663925531323118006&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mark-arts",
      "poi_latitude": "37.7074294",
      "poi_longitude": "-97.2464034",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-634-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67a8-7373-abc2-bef3ee09d04e",
        "storage_key": "property/6767906449165596/019cfb3d-67a8-7373-abc2-bef3ee09d04e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsYVU6vL8uocRtrGvmkdxYdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_be984fc0-c2a9-4c63-818c-9ab7cd6e3d4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Andover Central Park",
      "poi_type": "Entertainment",
      "poi_address": "1607 E Central Ave, Andover, KS 67002, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this park offers a dog park with separate areas for large and small dogs, a playground, walking paths, and a splash pad. They highlight the well-maintained grounds, clean facilities, and beautiful scenery. They also like the amphitheater and disc golf course.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019d7912-7c2b-71cb-bff5-588901d800ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7c2b-71cb-bff5-588901d800ba",
        "storage_key": "property/6767906449165596/019d7912-7c2b-71cb-bff5-588901d800ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.andoverks.com/17/Parks-and-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=4377216440004126022&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "andover-central-park",
      "poi_latitude": "37.691736",
      "poi_longitude": "-97.117562",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-733-1303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-67b1-701c-aa1e-821f15223eba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-67b1-701c-aa1e-821f15223eba",
        "storage_key": "property/6767906449165596/019cfb3d-67b1-701c-aa1e-821f15223eba.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVTf7zn_uocRRiVyIyn_vjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a23e5c02-96d2-4a6d-abce-e3e419358641",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Andover Central High School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "andover-central-high-school",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6ff64a74-d13c-4830-87ef-5120cc1c8c33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "Tianluo Bistro",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "tianluo-bistro",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4e0adc35-20ca-46bf-935f-75107070eda1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "poi_name": "All Star Adventures",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "all-star-adventures",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_ed01aa0050ffa62d83918bb1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_db29824a8759012f077a4b6a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7eba68ef652272dc08037883",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ca93505c14631aa0adb7e3f5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_cc1f1c784890e191555545dd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_8d4539c385e1fc573684fb9a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_7aab19a5-5716-4945-a135-feb9e8234e71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "rating": "5.0",
      "name": "David Hutcherson",
      "text": "My wife and I moved here in April 2025. The management and office staff bent over backwards to help us each step of the way, before and after our move.\n\nBeforehand, the management had scheduled the carpet to be replaced, but it wasn't able to be done until the day of our move. We had constant updates from the office on the job and they discounted us for the time we didn't have access to the apartment.\n\nThey also guided us through everything from policy on emotional support animals to helping us with resolving some past concerns to make our move as smooth as possible.\n\nAfter we moved in, they made sure that a disabled parking spot was designated within a comfortable distance from our front door; including updates on the work request, about the disabled sign being ordered, and approximately when the sign would be placed.\n\nThe property is well maintained, down to a daily walk around the residences by maintenance staff to pick up any small items of trash they see. Lawn maintenance contractors are here to keep the property neat on a regular basis, the trash dumpsters are emptied on a schedule that keeps the containers from overflowing and any odor to a minimum. The parking areas are kept clean.\n\nThe apartment itself is the best one in which we've lived. The kitchen is big and the overall floor plan is spacious and comfortable.\n\nWe really appreciate everything they do to make our daily lives as pleasant and peaceful as possible.\n\nWe highly recommend The Cottages At Crestview!",
      "date": "2025-04-29",
      "title": ""
    },
    {
      "id": "custom_34c04be3-e15f-418b-804a-7135d7235113",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "rating": "5.0",
      "name": "Lucky_ g",
      "text": "I’ve recently had the chance to work with Abby on getting my ideal apartment and it has been a wonderful and stress free experience! She has been very attentive to my needs and likes and has been extremely helpful on showing me the different model homes that they have available considering things like views, sunlight and spacing of the apartment which are important to me. We were able to stay past their regular hours to fill out the application with her assistance which I really appreciated as they are able to work with my schedule. The amenities were very nice and I know living here would be an enjoyable experience.",
      "date": "2025-04-30",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_3e68ebd0-0d6a-41f7-a8c7-2cafff073a74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-ee1e-7324-a361-474c770c10e2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of a modern apartment living room and kitchen area.",
        "public_id": "019cfb3d-ee1e-7324-a361-474c770c10e2",
        "storage_key": "property/6767906449165596/019cfb3d-ee1e-7324-a361-474c770c10e2.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Cottages at Crestview Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=5f44d972601bdb1ec052f449"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a03b3-6a2d-7349-b688-a50e9b635ba5",
      "lead_source": "LANDING_PAGE",
      "name": "case-cottages-at-crestview-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596"
    },
    {
      "lead_collector_id": "019cf79d-37e3-7599-a7ac-42b93e55e53b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "cottages-at-crestview",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "pool-apartments-wichita-ks",
      "search_query": "pool apartments Wichita KS",
      "category": "Amenity",
      "h1_title": "Premier Pool Apartments in Wichita KS",
      "h2_subtitle": "Discover top-tier pool apartments in Wichita KS. Enjoy leisure and comfort at the Cottages at Crestview, where luxury and location blend seamlessly.",
      "page_copy": "Experience unparalleled relaxation at the Cottages at Crestview, your premier choice for pool apartments in Wichita, KS. Dive into a refreshing lifestyle with our luxurious pool, where sunny days become more enjoyable and relaxation is always within reach. Nestled in a vibrant neighborhood, our community offers an inviting oasis complete with modern amenities, fostering a sense of tranquility and community among residents. \n\nOur Wichita location presents spacious one, two, and three-bedroom apartment homes, designed with your comfort in mind. Enjoy a combination of style and functionality with features such as carpet and tile floors, a welcoming lounge, and state-of-the-art fitness facilities. At Cottages at Crestview, you'll find not just an apartment, but a lifestyle that exudes elegance and ease. Schedule a tour today and discover your dream pool apartment home in Wichita, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in Wichita KS - Cottages at Crestview",
      "seo_description": "Explore pool apartments in Wichita, KS at Cottages at Crestview. Enjoy a modern lifestyle with premier amenities and a luxurious pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "dog-park-apartments-near-wichita",
      "search_query": "dog park apartments near Wichita",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments Near Wichita",
      "h2_subtitle": "Find your perfect home with a dog park near Wichita. Enjoy pet-friendly living at the Cottages at Crestview, where pets are family.",
      "page_copy": "Welcome to the Cottages at Crestview, your ideal destination for dog park apartments near Wichita, where both you and your furry friend will feel right at home. Located just a short drive from Wichita, our pet-friendly community offers a dedicated dog park, providing an excellent space for your pets to stretch, play, and socialize in a safe environment.\n\nAt Cottages at Crestview, we boast spacious one, two, and three-bedroom floor plans tailored for comfortable living. Alongside our dog park, enjoy top-notch amenities including a relaxing pool, a state-of-the-art fitness center, and a welcoming lounge. Each apartment features modern interiors, complete with carpet and tile flooring, designed to offer both style and practicality. Make the Cottages at Crestview your top choice for dog park apartments near Wichita, where exceptional living is matched by exceptional amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments Near Wichita - Cottages at Crestview",
      "seo_description": "Discover dog park apartments near Wichita at Cottages at Crestview. Experience premier pet-friendly amenities and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-67206",
      "search_query": "fitness center apartments 67206",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in 67206",
      "h2_subtitle": "Explore fitness center apartments in the 67206 area. Achieve your health goals at the Cottages at Crestview with our state-of-the-art facilities.",
      "page_copy": "Elevate your lifestyle at the Cottages at Crestview, ideal fitness center apartments in the heart of the 67206 area code. Our state-of-the-art fitness center is designed to support your active lifestyle, offering a welcoming environment where you can work towards your health and wellness goals right at your doorstep.\n\nDiscover a community that balances both convenience and modern luxury. With spacious one, two, and three-bedroom layouts, you’ll enjoy living in style while taking advantage of our excellent amenities, including a refreshing pool and vibrant lounge. Located in a prime Wichita neighborhood, the Cottages at Crestview provides a place where comfort meets lifestyle, making it the perfect choice for those seeking fitness-oriented apartment living in the 67206 area. Schedule a visit today and ignite your fitness journey with us!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in 67206 - Cottages at Crestview",
      "seo_description": "Discover fitness center apartments in 67206 at Cottages at Crestview. Enjoy modern amenities and a state-of-the-art fitness center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-wichita",
      "search_query": "pet-friendly apartments Wichita",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Wichita",
      "h2_subtitle": "Find the ideal pet-friendly apartments in Wichita at Cottages at Crestview. A haven for pet owners seeking comfort and community.",
      "page_copy": "Welcome to Cottages at Crestview, where pet-friendly apartments in Wichita redefine comfort and style. Our community embraces pet owners by offering spacious living spaces and a dedicated dog park, ensuring your furry friends feel just as at home as you do. Enjoy a vibrant environment where pets are family and a part of daily life.\n\nLocated in the heart of Wichita, the Cottages at Crestview offer expansive one, two, and three-bedroom units designed with modern living in mind. Beyond pet-friendly amenities, residents benefit from premier facilities like a sparkling pool and a cutting-edge fitness center. Enjoy beautiful interiors featuring carpet and tile floors, crafting a perfect retreat after an active day with your pet. Join a community that values the connection between you and your pet. Schedule a tour and discover the best pet-friendly living Wichita has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Wichita - Cottages at Crestview",
      "seo_description": "Explore pet-friendly apartments in Wichita at Cottages at Crestview. Enjoy spacious living and pet amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "apartment-with-air-conditioning-wichita",
      "search_query": "apartment with air conditioning in Wichita",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Wichita",
      "h2_subtitle": "Discover cool comfort in Wichita with our air-conditioned apartments. Cottages at Crestview offers a refreshing living experience.",
      "page_copy": "For those seeking an apartment with air conditioning in Wichita, the Cottages at Crestview offers the perfect match. Each unit in our community is equipped with advanced air conditioning, providing a haven of comfort during the warm Kansas summers. Designed with modern living in mind, our residences ensure climate control is just one of the many features you will enjoy.\n\nAt Cottages at Crestview, you'll find spacious one, two, and three-bedroom floor plans that cater to diverse lifestyle needs. Beyond air conditioning, residents have access to a range of amenities including a refreshing pool, an innovative fitness center, and a cozy lounge. Our community, located conveniently in Wichita, promises a harmonious blend of comfort and style. Experience the luxury of air-conditioned living. Join us at Cottages at Crestview today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning in Wichita - Cottages at Crestview",
      "seo_description": "Find apartments with air conditioning in Wichita at Cottages at Crestview. Experience a comfortable and refreshed living environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-wichita-ks",
      "search_query": "one bedroom apartments wichita ks",
      "category": "Floorplan",
      "h1_title": "One-Bedroom Apartments in Wichita, KS",
      "h2_subtitle": "Explore exceptional one-bedroom apartments in Wichita, KS. Cottages at Crestview offers elegance and comfort in every corner.",
      "page_copy": "Experience the allure of one-bedroom apartments at Cottages at Crestview, perfectly located in Wichita, KS. Our thoughtfully designed one-bedroom units provide a blend of comfort, style, and functionality, ideal for individuals seeking a cozy retreat with modern amenities. Enjoy beautiful interiors, featuring both carpet and tile flooring, catering to your lifestyle and aesthetic preferences.\n\nAt Cottages at Crestview, residents benefit from much more than just a place to live. Our community offers an array of sought-after amenities, including a sparkling pool, a state-of-the-art fitness center, and sprawling lounge spaces. Located in a vibrant area of Wichita, you're never far from dining, shopping, and local attractions. Discover the perfect one-bedroom apartment that meets all your needs; visit Cottages at Crestview and explore your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One-Bedroom Apartments in Wichita, KS - Cottages at Crestview",
      "seo_description": "Explore one-bedroom apartments in Wichita, KS at Cottages at Crestview. Enjoy modern design and excellent amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-crestview",
      "search_query": "two bedroom apartments near crestview",
      "category": "Floorplan",
      "h1_title": "Two-Bedroom Apartments Near Crestview",
      "h2_subtitle": "Discover spacious two-bedroom apartments near Crestview. Experience the luxury and comfort at Cottages at Crestview.",
      "page_copy": "Cottages at Crestview offers two-bedroom apartments near Crestview, providing a perfect blend of space and comfort for roommates or small families. Designed for modern living, our two-bedroom units come with an array of amenities, including dining rooms and spacious layouts that make it easy to entertain or relax.\n\nLocated in Wichita, near Crestview, our community is just minutes away from local attractions and conveniences. Enjoy access to a rejuvenating pool, a fully-equipped fitness center, and stylish lounge areas that enhance your lifestyle. Each apartment showcases quality finishes like carpet and tile floors, creating a welcoming ambiance. Explore the vibrant community at Cottages at Crestview, where your ideal two-bedroom apartment awaits. Schedule a visit and find your new home near Crestview today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments Near Crestview - Cottages at Crestview",
      "seo_description": "Find spacious two-bedroom apartments near Crestview at Cottages at Crestview. Enjoy modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-sedgwick-county",
      "search_query": "three bedroom apartments sedgwick county",
      "category": "Floorplan",
      "h1_title": "Three-Bedroom Apartments in Sedgwick County",
      "h2_subtitle": "Explore spacious three-bedroom apartments in Sedgwick County. Cottages at Crestview offers refined living in a vibrant community.",
      "page_copy": "Searching for three-bedroom apartments in Sedgwick County? Look no further than Cottages at Crestview. Our expansive three-bedroom units cater perfectly to growing families or those needing extra space. Each apartment blends style with functionality, featuring ample living areas that provide a homely and welcoming environment.\n\nLocated in the heart of Sedgwick County, our community is equipped with premier amenities, including a sparkling pool and a cutting-edge fitness center. Enjoy gathering with friends in our comfortable lounge or take a stroll to the nearby attractions Wichita has to offer. With thoughtfully finalized interiors featuring carpet and tile flooring, our three-bedroom apartments at Cottages at Crestview are designed to fit your lifestyle perfectly. Discover the comfort of spacious living by visiting us today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three-Bedroom Apartments in Sedgwick County - Cottages at Crestview",
      "seo_description": "Find spacious three-bedroom apartments in Sedgwick County at Cottages at Crestview. Enjoy premier amenities and a vibrant community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "apartments-near-wichita-state-university-kansas",
      "search_query": "apartments near wichita state university kansas",
      "category": "School",
      "h1_title": "Apartments Near Wichita State University, Kansas",
      "h2_subtitle": "Find outstanding apartments near Wichita State University, Kansas. Cottages at Crestview offers an ideal location for students and staff.",
      "page_copy": "Cottages at Crestview offers ideally located apartments near Wichita State University, Kansas, perfect for students, faculty, and staff seeking comfortable and stylish living spaces. Our community provides one, two, and three-bedroom apartments designed with modern needs in mind, ensuring a convenient commute to campus and all the excitement Wichita has to offer.\n\nWithin our vibrant community, residents enjoy amenities such as a refreshing pool, a state-of-the-art fitness center, and a lively lounge, making it easy to unwind after classes or work. Situated perfectly in Wichita, Cottages at Crestview is more than just a place to live; it’s a place to thrive. Boasting easy access to local eateries, shopping, and entertainment venues, you’ll find relaxation and recreation are never far away. Schedule a tour today and discover why our apartments near Wichita State University, Kansas, are the ideal choice for student and professional living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wichita State University, Kansas - Cottages at Crestview",
      "seo_description": "Find prime apartments near Wichita State University, Kansas at Cottages at Crestview with modern amenities and an ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "cottages-at-crestview-near-butler-community-college-andover",
      "search_query": "cottages at crestview near butler community college andover",
      "category": "School",
      "h1_title": "Cottages at Crestview Near Butler Community College",
      "h2_subtitle": "Discover Cottages at Crestview, conveniently located near Butler Community College in Andover, offering premium amenities and spacious living.",
      "page_copy": "Cottages at Crestview presents an ideal living option for those needing convenient access to Butler Community College in Andover. Our community offers a selection of one, two, and three-bedroom apartments, catering to students and professionals alike, ensuring a short commute and maximizing study or relaxation time. \n\nResidents at Cottages at Crestview enjoy a suite of exceptional amenities designed to enhance everyday living. Unwind by our refreshing pool or stay active in the state-of-the-art fitness center. With beautifully finished interiors that include carpet and tile floors, each apartment provides a comfortable and stylish retreat. Located strategically near shopping, dining, and entertainment options in Wichita, you’ll find everything you need close by. Experience the benefits of living near Butler Community College in Andover—visit Cottages at Crestview today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cottages at Crestview Near Butler Community College",
      "seo_description": "Cottages at Crestview offers spacious living and amenities near Butler Community College Andover. Discover your new home with us today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "apartments-close-to-woolsey-hall-wichita",
      "search_query": "apartments close to woolsey hall wichita",
      "category": "School",
      "h1_title": "Apartments Close to Woolsey Hall, Wichita",
      "h2_subtitle": "Discover apartments close to Woolsey Hall, Wichita. Cottages at Crestview offers modern living near educational and cultural hubs.",
      "page_copy": "If you’re seeking apartments close to Woolsey Hall in Wichita, Cottages at Crestview provides a perfect blend of comfort and convenience. Our community is designed to accommodate the needs of students and professionals alike, offering a range of one, two, and three-bedroom apartments ideally situated to provide easy access to the educational venues and cultural offerings of the area.\n\nEnjoy a relaxing lifestyle with our array of splendid amenities. Whether it's taking a dip in the pool, working out at the modern fitness center, or socializing in our cozy lounge, Cottages at Crestview makes it easy to balance work, study, and downtime. Our location not only provides a quick commute to Woolsey Hall but also places you at the heart of Wichita’s vibrant social scene, close to restaurants, shops, and entertainment. Experience the best of apartment living near Woolsey Hall by visiting Cottages at Crestview today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Woolsey Hall, Wichita - Cottages at Crestview",
      "seo_description": "Find modern apartments close to Woolsey Hall, Wichita at Cottages at Crestview. Enjoy a convenient location and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "apartments-near-wesley-medical-center-wichita-ks",
      "search_query": "apartments near Wesley Medical Center Wichita KS",
      "category": "Hospital",
      "h1_title": "Apartments Near Wesley Medical Center, Wichita KS",
      "h2_subtitle": "Explore apartments near Wesley Medical Center, Wichita KS, with modern amenities and ample living spaces at Cottages at Crestview.",
      "page_copy": "Cottages at Crestview offers exceptional apartments near Wesley Medical Center, Wichita KS, perfect for healthcare professionals, patients, and families seeking comfortable accommodations close to the hospital. Our one, two, and three-bedroom floor plans cater to diverse lifestyle needs, providing a home with easy access and convenience.\n\nWith top-notch amenities, residents enjoy the benefits of a refreshing pool, a well-equipped fitness center ideal for staying active, and a relaxing lounge area to unwind. Located in the vibrant city of Wichita, our community not only ensures a quick commute to Wesley Medical Center but also places you in proximity to the city’s best shopping, dining, and entertainment venues. Experience the perfect blend of location and luxury by choosing Cottages at Crestview as your home near Wesley Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wesley Medical Center, Wichita KS",
      "seo_description": "Discover comfort and convenience with apartments near Wesley Medical Center, Wichita KS, at Cottages at Crestview with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "cottages-at-crestview-close-to-ascension-via-christi-st-joseph",
      "search_query": "Cottages at Crestview close to Ascension Via Christi St. Joseph",
      "category": "Hospital",
      "h1_title": "Cottages at Crestview Near Ascension Via Christi St. Joseph",
      "h2_subtitle": "Find Cottages at Crestview conveniently close to Ascension Via Christi St. Joseph, offering modern amenities and spacious floor plans.",
      "page_copy": "Cottages at Crestview is perfectly situated for those needing proximity to Ascension Via Christi St. Joseph, offering an ideal blend of location and comfort. Our community provides spacious one, two, and three-bedroom apartments designed to meet the diverse needs of professionals and families looking for accommodation close to this renowned medical facility.\n\nExperience an elevated lifestyle with our outstanding amenities, including a refreshing pool that beckons relaxation, a state-of-the-art fitness center for maintaining healthy routines, and a dog park for your furry friends. Nestled in a thriving Wichita neighborhood, Cottages at Crestview ensures you’re just moments away from Ascension Via Christi St. Joseph while also being near shopping, dining, and entertainment options. Discover convenience and comfort with Cottages at Crestview today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cottages at Crestview Near Ascension Via Christi St. Joseph",
      "seo_description": "Explore Cottages at Crestview, strategically close to Ascension Via Christi St. Joseph, offering spacious living and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "apartments-near-great-plains-nature-center-wichita",
      "search_query": "apartments near great plains nature center wichita",
      "category": "Park",
      "h1_title": "Apartments Near Great Plains Nature Center, Wichita",
      "h2_subtitle": "Live close to nature with apartments near Great Plains Nature Center, Wichita, at Cottages at Crestview, offering a serene living environment.",
      "page_copy": "Experience the tranquility of living near the Great Plains Nature Center in Wichita by making Cottages at Crestview your new home. Ideal for nature enthusiasts and families, our community offers spacious one, two, and three-bedroom apartments that put you in close proximity to the stunning landscapes and educational opportunities provided by the nature center.\n\nAt Cottages at Crestview, enjoy modern amenities that complement your active lifestyle, such as a refreshing pool, fitness center, and comfortable lounge spaces. Our location not only offers quick access to walking trails and the natural beauty of Great Plains Nature Center but also places you within reach of Wichita’s key shopping and dining districts. Embrace the convenience of suburban living with the joys of nature right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Great Plains Nature Center, Wichita",
      "seo_description": "Find serene apartments near Great Plains Nature Center, Wichita at Cottages at Crestview, offering modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "cottages-close-to-edgemoor-park-67206",
      "search_query": "cottages close to edgemoor park 67206",
      "category": "Park",
      "h1_title": "Cottages Close to Edgemoor Park, 67206",
      "h2_subtitle": "Discover cottages close to Edgemoor Park, 67206, at Cottages at Crestview, where comfort and community come together.",
      "page_copy": "Nestled in the bustling area of 67206, Cottages at Crestview is the perfect place for those seeking cottages close to Edgemoor Park. Our spacious one, two, and three-bedroom floor plans cater to diverse living needs, making it an ideal choice for families and individuals alike. Enjoy the fresh air and recreational facilities that Edgemoor Park has to offer, just a short distance from your new home.\n\nCottages at Crestview pairs convenience with comfort through top amenities designed to enhance your lifestyle. Dive into our shimmering pool, maintain your fitness routine at our state-of-the-art gym, or unwind in our cozy lounge. With the added benefit of being near Edgemoor Park, you’ll have plenty of opportunities for outdoor activities and relaxation. Make the most of Wichita living by choosing a home that places you in the heart of both community and nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cottages Close to Edgemoor Park, 67206",
      "seo_description": "Find cozy cottages close to Edgemoor Park, 67206 at Cottages at Crestview, featuring spacious living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "wichita-ks-apartments-by-fairmount-park",
      "search_query": "wichita ks apartments by fairmount park",
      "category": "Park",
      "h1_title": "Wichita KS Apartments by Fairmount Park",
      "h2_subtitle": "Explore Wichita, KS apartments by Fairmount Park at Cottages at Crestview, offering comfort and convenience.",
      "page_copy": "For those seeking Wichita, KS apartments by Fairmount Park, Cottages at Crestview offers the ideal location and amenities to enhance your living experience. Our community features spacious one, two, and three-bedroom apartments designed to suit your lifestyle, just a short distance from the natural beauty and recreational opportunities of Fairmount Park.\n\nAt Cottages at Crestview, enjoy a host of premium amenities such as our inviting pool, fully-equipped fitness center, and serene lounge areas, all crafted to provide comfort and leisure. Situated in a prime Wichita location, you'll relish the ease of access to Fairmount Park's scenic trails and open spaces, alongside the city's vibrant dining and shopping venues. Experience the perfect blend of urban and natural living at Cottages at Crestview, where convenience meets tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wichita KS Apartments by Fairmount Park",
      "seo_description": "Discover Wichita KS apartments by Fairmount Park at Cottages at Crestview, featuring spacious layouts and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165596",
      "source": "generator",
      "page_item_url": "crestview-rentals-near-lw-clapp-park",
      "search_query": "crestview rentals near l.w. clapp park",
      "category": "Park",
      "h1_title": "Crestview Rentals Near L.W. Clapp Park",
      "h2_subtitle": "Find your home with Crestview rentals near L.W. Clapp Park, offering a balance of city life and nature.",
      "page_copy": "Discover the perfect harmony of comfort and location with Crestview rentals near L.W. Clapp Park. Cottages at Crestview provides a variety of one, two, and three-bedroom floor plans ideal for families, professionals, and students. Positioned conveniently near L.W. Clapp Park, our community allows you to enjoy leisurely walks, outdoor sports, and picnic experiences just moments away from your doorstep.\n\nCottages at Crestview is designed to offer everything you need for a modern lifestyle, including a sparkling pool for relaxation, a cutting-edge fitness center to keep up with your wellness goals, and an inviting lounge area where you can unwind or socialize. Living here means you're not only close to recreational spaces but also enjoy quick access to Wichita's thriving urban amenities. Embrace the vibrant yet serene atmosphere at Crestview in Wichita.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern buildings in the background.",
        "public_id": "019cfb3d-3d97-72f1-880b-515f63834736",
        "storage_key": "property/6767906449165596/019cfb3d-3d97-72f1-880b-515f63834736.webp",
        "width": 1240,
        "height": 698
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Crestview Rentals Near L.W. Clapp Park",
      "seo_description": "Explore Crestview rentals near L.W. Clapp Park at Cottages at Crestview, featuring spacious layouts and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5162"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-PGSXFEL10T"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18128851241"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/cottages-at-crestview/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W6D78TBR"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165596/019d1bd7-ad3a-72cd-892b-081a3751c885.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "4ba6d7ae-f6ae-4ccd-b092-d49ef6cc264b"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "833-772-5597"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "63c834b27949f79caa82cad3"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InZxM1VKUVlMd2x3UTN4dUlPODJsRHc9PSIsInZhbHVlIjoiS1c4SHkzRWJFa0xVNVM1NjdZNXJIUT09IiwibWFjIjoiZTA5NTZlM2U0ZjMzODlhNTZiNzIyMjM1ZTZhOTYzMzRkNGI3MDgyYTcwNjk1ZDkyOGNlMDA4YjkxZTUzZGYyZCJ9"
    }
  ],
  "custom_qb_id": "5162",
  "custom_ga4_id": "G-PGSXFEL10T",
  "custom_repli_id": "18128851241",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/cottages-at-crestview/register/",
  "custom_google_gtm_id": "GTM-W6D78TBR",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165596/019d1bd7-ad3a-72cd-892b-081a3751c885.pdf",
  "custom_rentgrata_property_id": "4ba6d7ae-f6ae-4ccd-b092-d49ef6cc264b",
  "custom_ppc_tracking_phone_number": "833-772-5597",
  "custom_residentboost_apartment_id": "63c834b27949f79caa82cad3",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InZxM1VKUVlMd2x3UTN4dUlPODJsRHc9PSIsInZhbHVlIjoiS1c4SHkzRWJFa0xVNVM1NjdZNXJIUT09IiwibWFjIjoiZTA5NTZlM2U0ZjMzODlhNTZiNzIyMjM1ZTZhOTYzMzRkNGI3MDgyYTcwNjk1ZDkyOGNlMDA4YjkxZTUzZGYyZCJ9"
};

export const generatedAt = '2026-08-27T21:38:47.275Z';
